/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AllFactoriesBaselinesControllerGetBaselinesParams,
  AllFactoriesBaselinesControllerListAvailableCostLinesParams,
  AllFactoriesBaselinesResponseDto,
  AllFactoriesLaborControllerHistoryParams,
  AllFactoriesLaborControllerRecordsParams,
  AllFactoriesLaborControllerWindowParams,
  AvailableCostLinesResponseDto,
  BaselineVersionDto,
  BaselinesResponseDto,
  BudgetsResponseDto,
  CostCategoriesResponseDto,
  CostCategoryDto,
  CostLineDto,
  CostLinesResponseDto,
  CostToProduceControllerProjectsParams,
  CostToProduceControllerWorkOrdersParams,
  CostToProduceProjectsDto,
  CostToProduceWorkOrdersDto,
  CreateCostLineDto,
  CreateCustomCostCategoryDto,
  GroupSettingsResponseDto,
  LaborControllerHistoryParams,
  LaborControllerRecordsParams,
  LaborControllerWindowParams,
  LaborEfficiencyDto,
  LaborHistoryDto,
  LaborRecordPageDto,
  LaborWindowDto,
  LaborWriteResponseDto,
  OperatingCostsControllerGetBaselinesParams,
  OperatingCostsControllerListAvailableCostLinesParams,
  OperatingCostsControllerListCostLinesParams,
  PartnerCostCategoriesControllerListParams,
  PartnerLaborWindowDto,
  PeriodValueResponseDto,
  PutBaselineDto,
  PutBudgetLineDto,
  PutBudgetLineResponseDto,
  PutGroupSettingsDto,
  PutLaborDayDto,
  PutPeriodValueDto,
  PutSupportLogEntryDto,
  PutSupportLogEntryResponseDto,
  ReassignLaborDto,
  SupportLogControllerGetDayParams,
  SupportLogControllerGetSummaryParams,
  SupportLogDayResponseDto,
  SupportLogSummaryResponseDto,
  UpdateCostLineDto
} from '../schemas';

import { customFetch } from '../../custom-fetch.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type operatingCostsControllerGetCostCategoriesResponse200 = {
  data: CostCategoriesResponseDto
  status: 200
}

export type operatingCostsControllerGetCostCategoriesResponse404 = {
  data: void
  status: 404
}

export type operatingCostsControllerGetCostCategoriesResponseSuccess = (operatingCostsControllerGetCostCategoriesResponse200) & {
  headers: Headers;
};
export type operatingCostsControllerGetCostCategoriesResponseError = (operatingCostsControllerGetCostCategoriesResponse404) & {
  headers: Headers;
};

export type operatingCostsControllerGetCostCategoriesResponse = (operatingCostsControllerGetCostCategoriesResponseSuccess | operatingCostsControllerGetCostCategoriesResponseError)

export const getOperatingCostsControllerGetCostCategoriesUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/operating-costs/cost-categories`
}

/**
 * The three Cost Groups with their predefined Cost Categories (macro to micro) followed by the partner's custom types, with default baseline periods and capabilities. Operations for Value-adding operation lines come from GET /operations.
 * @summary The Cost Category lists: predefined, then the partner's own types
 */
export const operatingCostsControllerGetCostCategories = async (factoryId: string, options?: Parameters<typeof customFetch>[1]): Promise<operatingCostsControllerGetCostCategoriesResponse> => {

  return customFetch<operatingCostsControllerGetCostCategoriesResponse>(getOperatingCostsControllerGetCostCategoriesUrl(factoryId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOperatingCostsControllerGetCostCategoriesQueryKey = (factoryId: string,) => {
    return [
    `/factories/${factoryId}/operating-costs/cost-categories`
    ] as const;
    }


export const getOperatingCostsControllerGetCostCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError = void>(factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperatingCostsControllerGetCostCategoriesQueryKey(factoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>> = ({ signal }) => operatingCostsControllerGetCostCategories(factoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperatingCostsControllerGetCostCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>>
export type OperatingCostsControllerGetCostCategoriesQueryError = void


export function useOperatingCostsControllerGetCostCategories<TData = Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError = void>(
 factoryId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>,
          TError,
          Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatingCostsControllerGetCostCategories<TData = Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>,
          TError,
          Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatingCostsControllerGetCostCategories<TData = Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The Cost Category lists: predefined, then the partner's own types
 */

export function useOperatingCostsControllerGetCostCategories<TData = Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperatingCostsControllerGetCostCategoriesQueryOptions(factoryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary The Cost Category lists: predefined, then the partner's own types
 */
export const prefetchOperatingCostsControllerGetCostCategoriesQuery = async <TData = Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError = void>(
 queryClient: QueryClient, factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperatingCostsControllerGetCostCategoriesQueryOptions(factoryId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getOperatingCostsControllerGetCostCategoriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError = void>(factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperatingCostsControllerGetCostCategoriesQueryKey(factoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>> = ({ signal }) => operatingCostsControllerGetCostCategories(factoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperatingCostsControllerGetCostCategoriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>>
export type OperatingCostsControllerGetCostCategoriesSuspenseQueryError = void


export function useOperatingCostsControllerGetCostCategoriesSuspense<TData = Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError = void>(
 factoryId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatingCostsControllerGetCostCategoriesSuspense<TData = Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatingCostsControllerGetCostCategoriesSuspense<TData = Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The Cost Category lists: predefined, then the partner's own types
 */

export function useOperatingCostsControllerGetCostCategoriesSuspense<TData = Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetCostCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperatingCostsControllerGetCostCategoriesSuspenseQueryOptions(factoryId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type operatingCostsControllerListAvailableCostLinesResponse200 = {
  data: AvailableCostLinesResponseDto
  status: 200
}

export type operatingCostsControllerListAvailableCostLinesResponse400 = {
  data: void
  status: 400
}

export type operatingCostsControllerListAvailableCostLinesResponse404 = {
  data: void
  status: 404
}

export type operatingCostsControllerListAvailableCostLinesResponseSuccess = (operatingCostsControllerListAvailableCostLinesResponse200) & {
  headers: Headers;
};
export type operatingCostsControllerListAvailableCostLinesResponseError = (operatingCostsControllerListAvailableCostLinesResponse400 | operatingCostsControllerListAvailableCostLinesResponse404) & {
  headers: Headers;
};

export type operatingCostsControllerListAvailableCostLinesResponse = (operatingCostsControllerListAvailableCostLinesResponseSuccess | operatingCostsControllerListAvailableCostLinesResponseError)

export const getOperatingCostsControllerListAvailableCostLinesUrl = (factoryId: string,
    params: OperatingCostsControllerListAvailableCostLinesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/factories/${factoryId}/operating-costs/available-cost-lines?${stringifiedParams}` : `/factories/${factoryId}/operating-costs/available-cost-lines`
}

/**
 * Every Cost Category of the group (predefined, then the partner's own types) and, for Value-adding, every operation, that has no active line in this factory and no active All factories parent. A row whose only lines are archived carries archived_line_id — unarchive that line instead of adding a second.
 * @summary The Cost Lines this factory has not enabled yet
 */
export const operatingCostsControllerListAvailableCostLines = async (factoryId: string,
    params: OperatingCostsControllerListAvailableCostLinesParams, options?: Parameters<typeof customFetch>[1]): Promise<operatingCostsControllerListAvailableCostLinesResponse> => {

  return customFetch<operatingCostsControllerListAvailableCostLinesResponse>(getOperatingCostsControllerListAvailableCostLinesUrl(factoryId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOperatingCostsControllerListAvailableCostLinesQueryKey = (factoryId: string,
    params?: OperatingCostsControllerListAvailableCostLinesParams,) => {
    return [
    `/factories/${factoryId}/operating-costs/available-cost-lines`, ...(params ? [params] : [])
    ] as const;
    }


export const getOperatingCostsControllerListAvailableCostLinesQueryOptions = <TData = Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError = void>(factoryId: string,
    params: OperatingCostsControllerListAvailableCostLinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperatingCostsControllerListAvailableCostLinesQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>> = ({ signal }) => operatingCostsControllerListAvailableCostLines(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperatingCostsControllerListAvailableCostLinesQueryResult = NonNullable<Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>>
export type OperatingCostsControllerListAvailableCostLinesQueryError = void


export function useOperatingCostsControllerListAvailableCostLines<TData = Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError = void>(
 factoryId: string,
    params: OperatingCostsControllerListAvailableCostLinesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>,
          TError,
          Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatingCostsControllerListAvailableCostLines<TData = Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError = void>(
 factoryId: string,
    params: OperatingCostsControllerListAvailableCostLinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>,
          TError,
          Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatingCostsControllerListAvailableCostLines<TData = Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError = void>(
 factoryId: string,
    params: OperatingCostsControllerListAvailableCostLinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The Cost Lines this factory has not enabled yet
 */

export function useOperatingCostsControllerListAvailableCostLines<TData = Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError = void>(
 factoryId: string,
    params: OperatingCostsControllerListAvailableCostLinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperatingCostsControllerListAvailableCostLinesQueryOptions(factoryId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary The Cost Lines this factory has not enabled yet
 */
export const prefetchOperatingCostsControllerListAvailableCostLinesQuery = async <TData = Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError = void>(
 queryClient: QueryClient, factoryId: string,
    params: OperatingCostsControllerListAvailableCostLinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperatingCostsControllerListAvailableCostLinesQueryOptions(factoryId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getOperatingCostsControllerListAvailableCostLinesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError = void>(factoryId: string,
    params: OperatingCostsControllerListAvailableCostLinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperatingCostsControllerListAvailableCostLinesQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>> = ({ signal }) => operatingCostsControllerListAvailableCostLines(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperatingCostsControllerListAvailableCostLinesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>>
export type OperatingCostsControllerListAvailableCostLinesSuspenseQueryError = void


export function useOperatingCostsControllerListAvailableCostLinesSuspense<TData = Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError = void>(
 factoryId: string,
    params: OperatingCostsControllerListAvailableCostLinesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatingCostsControllerListAvailableCostLinesSuspense<TData = Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError = void>(
 factoryId: string,
    params: OperatingCostsControllerListAvailableCostLinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatingCostsControllerListAvailableCostLinesSuspense<TData = Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError = void>(
 factoryId: string,
    params: OperatingCostsControllerListAvailableCostLinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The Cost Lines this factory has not enabled yet
 */

export function useOperatingCostsControllerListAvailableCostLinesSuspense<TData = Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError = void>(
 factoryId: string,
    params: OperatingCostsControllerListAvailableCostLinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperatingCostsControllerListAvailableCostLinesSuspenseQueryOptions(factoryId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type operatingCostsControllerListCostLinesResponse200 = {
  data: CostLinesResponseDto
  status: 200
}

export type operatingCostsControllerListCostLinesResponse404 = {
  data: void
  status: 404
}

export type operatingCostsControllerListCostLinesResponseSuccess = (operatingCostsControllerListCostLinesResponse200) & {
  headers: Headers;
};
export type operatingCostsControllerListCostLinesResponseError = (operatingCostsControllerListCostLinesResponse404) & {
  headers: Headers;
};

export type operatingCostsControllerListCostLinesResponse = (operatingCostsControllerListCostLinesResponseSuccess | operatingCostsControllerListCostLinesResponseError)

export const getOperatingCostsControllerListCostLinesUrl = (factoryId: string,
    params?: OperatingCostsControllerListCostLinesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/factories/${factoryId}/operating-costs/cost-lines?${stringifiedParams}` : `/factories/${factoryId}/operating-costs/cost-lines`
}

/**
 * The Cost Lines of this factory (optionally one group), with the baseline-period settings for all three groups, the partner currency and the partner week anchor. virtual_lines lists the All factories parents the factory has no line for — the Baselines tab's virtual rows — so the Support Log can key time against them; keying one creates the factory's line.
 * @summary A factory's Cost Lines
 */
export const operatingCostsControllerListCostLines = async (factoryId: string,
    params?: OperatingCostsControllerListCostLinesParams, options?: Parameters<typeof customFetch>[1]): Promise<operatingCostsControllerListCostLinesResponse> => {

  return customFetch<operatingCostsControllerListCostLinesResponse>(getOperatingCostsControllerListCostLinesUrl(factoryId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOperatingCostsControllerListCostLinesQueryKey = (factoryId: string,
    params?: OperatingCostsControllerListCostLinesParams,) => {
    return [
    `/factories/${factoryId}/operating-costs/cost-lines`, ...(params ? [params] : [])
    ] as const;
    }


export const getOperatingCostsControllerListCostLinesQueryOptions = <TData = Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError = void>(factoryId: string,
    params?: OperatingCostsControllerListCostLinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperatingCostsControllerListCostLinesQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>> = ({ signal }) => operatingCostsControllerListCostLines(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperatingCostsControllerListCostLinesQueryResult = NonNullable<Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>>
export type OperatingCostsControllerListCostLinesQueryError = void


export function useOperatingCostsControllerListCostLines<TData = Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError = void>(
 factoryId: string,
    params: undefined |  OperatingCostsControllerListCostLinesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>,
          TError,
          Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatingCostsControllerListCostLines<TData = Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError = void>(
 factoryId: string,
    params?: OperatingCostsControllerListCostLinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>,
          TError,
          Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatingCostsControllerListCostLines<TData = Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError = void>(
 factoryId: string,
    params?: OperatingCostsControllerListCostLinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A factory's Cost Lines
 */

export function useOperatingCostsControllerListCostLines<TData = Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError = void>(
 factoryId: string,
    params?: OperatingCostsControllerListCostLinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperatingCostsControllerListCostLinesQueryOptions(factoryId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary A factory's Cost Lines
 */
export const prefetchOperatingCostsControllerListCostLinesQuery = async <TData = Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError = void>(
 queryClient: QueryClient, factoryId: string,
    params?: OperatingCostsControllerListCostLinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperatingCostsControllerListCostLinesQueryOptions(factoryId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getOperatingCostsControllerListCostLinesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError = void>(factoryId: string,
    params?: OperatingCostsControllerListCostLinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperatingCostsControllerListCostLinesQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>> = ({ signal }) => operatingCostsControllerListCostLines(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperatingCostsControllerListCostLinesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>>
export type OperatingCostsControllerListCostLinesSuspenseQueryError = void


export function useOperatingCostsControllerListCostLinesSuspense<TData = Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError = void>(
 factoryId: string,
    params: undefined |  OperatingCostsControllerListCostLinesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatingCostsControllerListCostLinesSuspense<TData = Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError = void>(
 factoryId: string,
    params?: OperatingCostsControllerListCostLinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatingCostsControllerListCostLinesSuspense<TData = Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError = void>(
 factoryId: string,
    params?: OperatingCostsControllerListCostLinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A factory's Cost Lines
 */

export function useOperatingCostsControllerListCostLinesSuspense<TData = Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError = void>(
 factoryId: string,
    params?: OperatingCostsControllerListCostLinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerListCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperatingCostsControllerListCostLinesSuspenseQueryOptions(factoryId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type operatingCostsControllerCreateCostLineResponse201 = {
  data: CostLineDto
  status: 201
}

export type operatingCostsControllerCreateCostLineResponse400 = {
  data: void
  status: 400
}

export type operatingCostsControllerCreateCostLineResponse404 = {
  data: void
  status: 404
}

export type operatingCostsControllerCreateCostLineResponse409 = {
  data: void
  status: 409
}

export type operatingCostsControllerCreateCostLineResponse422 = {
  data: void
  status: 422
}

export type operatingCostsControllerCreateCostLineResponseSuccess = (operatingCostsControllerCreateCostLineResponse201) & {
  headers: Headers;
};
export type operatingCostsControllerCreateCostLineResponseError = (operatingCostsControllerCreateCostLineResponse400 | operatingCostsControllerCreateCostLineResponse404 | operatingCostsControllerCreateCostLineResponse409 | operatingCostsControllerCreateCostLineResponse422) & {
  headers: Headers;
};

export type operatingCostsControllerCreateCostLineResponse = (operatingCostsControllerCreateCostLineResponseSuccess | operatingCostsControllerCreateCostLineResponseError)

export const getOperatingCostsControllerCreateCostLineUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/operating-costs/cost-lines`
}

/**
 * Create a Cost Line from a predefined Cost Category (or an operation, for Value-adding). The name defaults to the Cost Category name; the customer renames it freely. The Cost Category is fixed once picked.
 * @summary Add a Cost Line
 */
export const operatingCostsControllerCreateCostLine = async (factoryId: string,
    createCostLineDto: CreateCostLineDto, options?: Parameters<typeof customFetch>[1]): Promise<operatingCostsControllerCreateCostLineResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<operatingCostsControllerCreateCostLineResponse>(getOperatingCostsControllerCreateCostLineUrl(factoryId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCostLineDto)
  }
);}





export const getOperatingCostsControllerCreateCostLineMutationKey = () => ['operatingCostsControllerCreateCostLine'] as const;

export const getOperatingCostsControllerCreateCostLineMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerCreateCostLine>>, TError,OperatingCostsControllerCreateCostLineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerCreateCostLine>>, TError,OperatingCostsControllerCreateCostLineMutationVariables, TContext> => {

const mutationKey = getOperatingCostsControllerCreateCostLineMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operatingCostsControllerCreateCostLine>>, OperatingCostsControllerCreateCostLineMutationVariables> = (props) => {
          const {factoryId,data} = props ?? {};

          return  operatingCostsControllerCreateCostLine(factoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperatingCostsControllerCreateCostLineMutationResult = NonNullable<Awaited<ReturnType<typeof operatingCostsControllerCreateCostLine>>>
    export type OperatingCostsControllerCreateCostLineMutationBody = CreateCostLineDto
    export type OperatingCostsControllerCreateCostLineMutationError = void
    export type OperatingCostsControllerCreateCostLineMutationVariables = {factoryId: string;data: CreateCostLineDto}

    /**
 * @summary Add a Cost Line
 */
export const useOperatingCostsControllerCreateCostLine = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerCreateCostLine>>, TError,OperatingCostsControllerCreateCostLineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operatingCostsControllerCreateCostLine>>,
        TError,
        OperatingCostsControllerCreateCostLineMutationVariables,
        TContext
      > => {
      return useMutation(getOperatingCostsControllerCreateCostLineMutationOptions(options), queryClient);
    }
    export type operatingCostsControllerUpdateCostLineResponse200 = {
  data: CostLineDto
  status: 200
}

export type operatingCostsControllerUpdateCostLineResponse404 = {
  data: void
  status: 404
}

export type operatingCostsControllerUpdateCostLineResponse409 = {
  data: void
  status: 409
}

export type operatingCostsControllerUpdateCostLineResponseSuccess = (operatingCostsControllerUpdateCostLineResponse200) & {
  headers: Headers;
};
export type operatingCostsControllerUpdateCostLineResponseError = (operatingCostsControllerUpdateCostLineResponse404 | operatingCostsControllerUpdateCostLineResponse409) & {
  headers: Headers;
};

export type operatingCostsControllerUpdateCostLineResponse = (operatingCostsControllerUpdateCostLineResponseSuccess | operatingCostsControllerUpdateCostLineResponseError)

export const getOperatingCostsControllerUpdateCostLineUrl = (factoryId: string,
    costLineId: string,) => {




  return `/factories/${factoryId}/operating-costs/cost-lines/${costLineId}`
}

/**
 * The Cost Category and operation are immutable once picked.
 * @summary Rename a Cost Line or set its Cost Code
 */
export const operatingCostsControllerUpdateCostLine = async (factoryId: string,
    costLineId: string,
    updateCostLineDto: UpdateCostLineDto, options?: Parameters<typeof customFetch>[1]): Promise<operatingCostsControllerUpdateCostLineResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<operatingCostsControllerUpdateCostLineResponse>(getOperatingCostsControllerUpdateCostLineUrl(factoryId,costLineId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateCostLineDto)
  }
);}





export const getOperatingCostsControllerUpdateCostLineMutationKey = () => ['operatingCostsControllerUpdateCostLine'] as const;

export const getOperatingCostsControllerUpdateCostLineMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerUpdateCostLine>>, TError,OperatingCostsControllerUpdateCostLineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerUpdateCostLine>>, TError,OperatingCostsControllerUpdateCostLineMutationVariables, TContext> => {

const mutationKey = getOperatingCostsControllerUpdateCostLineMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operatingCostsControllerUpdateCostLine>>, OperatingCostsControllerUpdateCostLineMutationVariables> = (props) => {
          const {factoryId,costLineId,data} = props ?? {};

          return  operatingCostsControllerUpdateCostLine(factoryId,costLineId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperatingCostsControllerUpdateCostLineMutationResult = NonNullable<Awaited<ReturnType<typeof operatingCostsControllerUpdateCostLine>>>
    export type OperatingCostsControllerUpdateCostLineMutationBody = UpdateCostLineDto
    export type OperatingCostsControllerUpdateCostLineMutationError = void
    export type OperatingCostsControllerUpdateCostLineMutationVariables = {factoryId: string;costLineId: string;data: UpdateCostLineDto}

    /**
 * @summary Rename a Cost Line or set its Cost Code
 */
export const useOperatingCostsControllerUpdateCostLine = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerUpdateCostLine>>, TError,OperatingCostsControllerUpdateCostLineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operatingCostsControllerUpdateCostLine>>,
        TError,
        OperatingCostsControllerUpdateCostLineMutationVariables,
        TContext
      > => {
      return useMutation(getOperatingCostsControllerUpdateCostLineMutationOptions(options), queryClient);
    }
    export type operatingCostsControllerArchiveCostLineResponse200 = {
  data: CostLineDto
  status: 200
}

export type operatingCostsControllerArchiveCostLineResponse404 = {
  data: void
  status: 404
}

export type operatingCostsControllerArchiveCostLineResponseSuccess = (operatingCostsControllerArchiveCostLineResponse200) & {
  headers: Headers;
};
export type operatingCostsControllerArchiveCostLineResponseError = (operatingCostsControllerArchiveCostLineResponse404) & {
  headers: Headers;
};

export type operatingCostsControllerArchiveCostLineResponse = (operatingCostsControllerArchiveCostLineResponseSuccess | operatingCostsControllerArchiveCostLineResponseError)

export const getOperatingCostsControllerArchiveCostLineUrl = (factoryId: string,
    costLineId: string,) => {




  return `/factories/${factoryId}/operating-costs/cost-lines/${costLineId}/archive`
}

/**
 * Sets archived_at. Past periods keep the figures already entered.
 * @summary Archive a Cost Line
 */
export const operatingCostsControllerArchiveCostLine = async (factoryId: string,
    costLineId: string, options?: Parameters<typeof customFetch>[1]): Promise<operatingCostsControllerArchiveCostLineResponse> => {

  return customFetch<operatingCostsControllerArchiveCostLineResponse>(getOperatingCostsControllerArchiveCostLineUrl(factoryId,costLineId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOperatingCostsControllerArchiveCostLineMutationKey = () => ['operatingCostsControllerArchiveCostLine'] as const;

export const getOperatingCostsControllerArchiveCostLineMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerArchiveCostLine>>, TError,OperatingCostsControllerArchiveCostLineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerArchiveCostLine>>, TError,OperatingCostsControllerArchiveCostLineMutationVariables, TContext> => {

const mutationKey = getOperatingCostsControllerArchiveCostLineMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operatingCostsControllerArchiveCostLine>>, OperatingCostsControllerArchiveCostLineMutationVariables> = (props) => {
          const {factoryId,costLineId} = props ?? {};

          return  operatingCostsControllerArchiveCostLine(factoryId,costLineId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperatingCostsControllerArchiveCostLineMutationResult = NonNullable<Awaited<ReturnType<typeof operatingCostsControllerArchiveCostLine>>>

    export type OperatingCostsControllerArchiveCostLineMutationError = void
    export type OperatingCostsControllerArchiveCostLineMutationVariables = {factoryId: string;costLineId: string}

    /**
 * @summary Archive a Cost Line
 */
export const useOperatingCostsControllerArchiveCostLine = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerArchiveCostLine>>, TError,OperatingCostsControllerArchiveCostLineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operatingCostsControllerArchiveCostLine>>,
        TError,
        OperatingCostsControllerArchiveCostLineMutationVariables,
        TContext
      > => {
      return useMutation(getOperatingCostsControllerArchiveCostLineMutationOptions(options), queryClient);
    }
    export type operatingCostsControllerUnarchiveCostLineResponse200 = {
  data: CostLineDto
  status: 200
}

export type operatingCostsControllerUnarchiveCostLineResponse404 = {
  data: void
  status: 404
}

export type operatingCostsControllerUnarchiveCostLineResponseSuccess = (operatingCostsControllerUnarchiveCostLineResponse200) & {
  headers: Headers;
};
export type operatingCostsControllerUnarchiveCostLineResponseError = (operatingCostsControllerUnarchiveCostLineResponse404) & {
  headers: Headers;
};

export type operatingCostsControllerUnarchiveCostLineResponse = (operatingCostsControllerUnarchiveCostLineResponseSuccess | operatingCostsControllerUnarchiveCostLineResponseError)

export const getOperatingCostsControllerUnarchiveCostLineUrl = (factoryId: string,
    costLineId: string,) => {




  return `/factories/${factoryId}/operating-costs/cost-lines/${costLineId}/unarchive`
}

/**
 * @summary Unarchive a Cost Line
 */
export const operatingCostsControllerUnarchiveCostLine = async (factoryId: string,
    costLineId: string, options?: Parameters<typeof customFetch>[1]): Promise<operatingCostsControllerUnarchiveCostLineResponse> => {

  return customFetch<operatingCostsControllerUnarchiveCostLineResponse>(getOperatingCostsControllerUnarchiveCostLineUrl(factoryId,costLineId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOperatingCostsControllerUnarchiveCostLineMutationKey = () => ['operatingCostsControllerUnarchiveCostLine'] as const;

export const getOperatingCostsControllerUnarchiveCostLineMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerUnarchiveCostLine>>, TError,OperatingCostsControllerUnarchiveCostLineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerUnarchiveCostLine>>, TError,OperatingCostsControllerUnarchiveCostLineMutationVariables, TContext> => {

const mutationKey = getOperatingCostsControllerUnarchiveCostLineMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operatingCostsControllerUnarchiveCostLine>>, OperatingCostsControllerUnarchiveCostLineMutationVariables> = (props) => {
          const {factoryId,costLineId} = props ?? {};

          return  operatingCostsControllerUnarchiveCostLine(factoryId,costLineId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperatingCostsControllerUnarchiveCostLineMutationResult = NonNullable<Awaited<ReturnType<typeof operatingCostsControllerUnarchiveCostLine>>>

    export type OperatingCostsControllerUnarchiveCostLineMutationError = void
    export type OperatingCostsControllerUnarchiveCostLineMutationVariables = {factoryId: string;costLineId: string}

    /**
 * @summary Unarchive a Cost Line
 */
export const useOperatingCostsControllerUnarchiveCostLine = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerUnarchiveCostLine>>, TError,OperatingCostsControllerUnarchiveCostLineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operatingCostsControllerUnarchiveCostLine>>,
        TError,
        OperatingCostsControllerUnarchiveCostLineMutationVariables,
        TContext
      > => {
      return useMutation(getOperatingCostsControllerUnarchiveCostLineMutationOptions(options), queryClient);
    }
    export type operatingCostsControllerPutBaselineResponse200 = {
  data: BaselineVersionDto
  status: 200
}

export type operatingCostsControllerPutBaselineResponse404 = {
  data: void
  status: 404
}

export type operatingCostsControllerPutBaselineResponse409 = {
  data: void
  status: 409
}

export type operatingCostsControllerPutBaselineResponse422 = {
  data: void
  status: 422
}

export type operatingCostsControllerPutBaselineResponseSuccess = (operatingCostsControllerPutBaselineResponse200) & {
  headers: Headers;
};
export type operatingCostsControllerPutBaselineResponseError = (operatingCostsControllerPutBaselineResponse404 | operatingCostsControllerPutBaselineResponse409 | operatingCostsControllerPutBaselineResponse422) & {
  headers: Headers;
};

export type operatingCostsControllerPutBaselineResponse = (operatingCostsControllerPutBaselineResponseSuccess | operatingCostsControllerPutBaselineResponseError)

export const getOperatingCostsControllerPutBaselineUrl = (factoryId: string,
    costLineId: string,) => {




  return `/factories/${factoryId}/operating-costs/cost-lines/${costLineId}/baseline`
}

/**
 * Appends a baseline version applying from effective_from (a period start) onward — never backwards; later versions keep winning from their own dates. Key any two of minutes/hourly rate/cost and the third derives; Overheads lines take cost only. An all-null payload clears the baseline from that period onward.
 * @summary Key a Cost Line baseline from a period onward
 */
export const operatingCostsControllerPutBaseline = async (factoryId: string,
    costLineId: string,
    putBaselineDto: PutBaselineDto, options?: Parameters<typeof customFetch>[1]): Promise<operatingCostsControllerPutBaselineResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<operatingCostsControllerPutBaselineResponse>(getOperatingCostsControllerPutBaselineUrl(factoryId,costLineId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putBaselineDto)
  }
);}





export const getOperatingCostsControllerPutBaselineMutationKey = () => ['operatingCostsControllerPutBaseline'] as const;

export const getOperatingCostsControllerPutBaselineMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerPutBaseline>>, TError,OperatingCostsControllerPutBaselineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerPutBaseline>>, TError,OperatingCostsControllerPutBaselineMutationVariables, TContext> => {

const mutationKey = getOperatingCostsControllerPutBaselineMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operatingCostsControllerPutBaseline>>, OperatingCostsControllerPutBaselineMutationVariables> = (props) => {
          const {factoryId,costLineId,data} = props ?? {};

          return  operatingCostsControllerPutBaseline(factoryId,costLineId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperatingCostsControllerPutBaselineMutationResult = NonNullable<Awaited<ReturnType<typeof operatingCostsControllerPutBaseline>>>
    export type OperatingCostsControllerPutBaselineMutationBody = PutBaselineDto
    export type OperatingCostsControllerPutBaselineMutationError = void
    export type OperatingCostsControllerPutBaselineMutationVariables = {factoryId: string;costLineId: string;data: PutBaselineDto}

    /**
 * @summary Key a Cost Line baseline from a period onward
 */
export const useOperatingCostsControllerPutBaseline = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerPutBaseline>>, TError,OperatingCostsControllerPutBaselineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operatingCostsControllerPutBaseline>>,
        TError,
        OperatingCostsControllerPutBaselineMutationVariables,
        TContext
      > => {
      return useMutation(getOperatingCostsControllerPutBaselineMutationOptions(options), queryClient);
    }
    export type operatingCostsControllerPutPeriodValueResponse200 = {
  data: PeriodValueResponseDto
  status: 200
}

export type operatingCostsControllerPutPeriodValueResponse404 = {
  data: void
  status: 404
}

export type operatingCostsControllerPutPeriodValueResponse409 = {
  data: void
  status: 409
}

export type operatingCostsControllerPutPeriodValueResponse422 = {
  data: void
  status: 422
}

export type operatingCostsControllerPutPeriodValueResponseSuccess = (operatingCostsControllerPutPeriodValueResponse200) & {
  headers: Headers;
};
export type operatingCostsControllerPutPeriodValueResponseError = (operatingCostsControllerPutPeriodValueResponse404 | operatingCostsControllerPutPeriodValueResponse409 | operatingCostsControllerPutPeriodValueResponse422) & {
  headers: Headers;
};

export type operatingCostsControllerPutPeriodValueResponse = (operatingCostsControllerPutPeriodValueResponseSuccess | operatingCostsControllerPutPeriodValueResponseError)

export const getOperatingCostsControllerPutPeriodValueUrl = (factoryId: string,
    costLineId: string,
    periodStart: string,) => {




  return `/factories/${factoryId}/operating-costs/cost-lines/${costLineId}/periods/${periodStart}`
}

/**
 * Edits that period alone, marked on screen — baseline and other periods unchanged; past periods edit the same way. The override lands on what the line keys (minutes for time-only lines, money for lines that carry money) and never back-solves the keyed pair. Per field: absent = unchanged, null = cleared; when the figure and note are both clear the cell's row is deleted.
 * @summary Override one period's figure, or set its note
 */
export const operatingCostsControllerPutPeriodValue = async (factoryId: string,
    costLineId: string,
    periodStart: string,
    putPeriodValueDto: PutPeriodValueDto, options?: Parameters<typeof customFetch>[1]): Promise<operatingCostsControllerPutPeriodValueResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<operatingCostsControllerPutPeriodValueResponse>(getOperatingCostsControllerPutPeriodValueUrl(factoryId,costLineId,periodStart),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putPeriodValueDto)
  }
);}





export const getOperatingCostsControllerPutPeriodValueMutationKey = () => ['operatingCostsControllerPutPeriodValue'] as const;

export const getOperatingCostsControllerPutPeriodValueMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerPutPeriodValue>>, TError,OperatingCostsControllerPutPeriodValueMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerPutPeriodValue>>, TError,OperatingCostsControllerPutPeriodValueMutationVariables, TContext> => {

const mutationKey = getOperatingCostsControllerPutPeriodValueMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operatingCostsControllerPutPeriodValue>>, OperatingCostsControllerPutPeriodValueMutationVariables> = (props) => {
          const {factoryId,costLineId,periodStart,data} = props ?? {};

          return  operatingCostsControllerPutPeriodValue(factoryId,costLineId,periodStart,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperatingCostsControllerPutPeriodValueMutationResult = NonNullable<Awaited<ReturnType<typeof operatingCostsControllerPutPeriodValue>>>
    export type OperatingCostsControllerPutPeriodValueMutationBody = PutPeriodValueDto
    export type OperatingCostsControllerPutPeriodValueMutationError = void
    export type OperatingCostsControllerPutPeriodValueMutationVariables = {factoryId: string;costLineId: string;periodStart: string;data: PutPeriodValueDto}

    /**
 * @summary Override one period's figure, or set its note
 */
export const useOperatingCostsControllerPutPeriodValue = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerPutPeriodValue>>, TError,OperatingCostsControllerPutPeriodValueMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operatingCostsControllerPutPeriodValue>>,
        TError,
        OperatingCostsControllerPutPeriodValueMutationVariables,
        TContext
      > => {
      return useMutation(getOperatingCostsControllerPutPeriodValueMutationOptions(options), queryClient);
    }
    export type operatingCostsControllerGetBaselinesResponse200 = {
  data: BaselinesResponseDto
  status: 200
}

export type operatingCostsControllerGetBaselinesResponse400 = {
  data: void
  status: 400
}

export type operatingCostsControllerGetBaselinesResponse404 = {
  data: void
  status: 404
}

export type operatingCostsControllerGetBaselinesResponseSuccess = (operatingCostsControllerGetBaselinesResponse200) & {
  headers: Headers;
};
export type operatingCostsControllerGetBaselinesResponseError = (operatingCostsControllerGetBaselinesResponse400 | operatingCostsControllerGetBaselinesResponse404) & {
  headers: Headers;
};

export type operatingCostsControllerGetBaselinesResponse = (operatingCostsControllerGetBaselinesResponseSuccess | operatingCostsControllerGetBaselinesResponseError)

export const getOperatingCostsControllerGetBaselinesUrl = (factoryId: string,
    params: OperatingCostsControllerGetBaselinesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/factories/${factoryId}/operating-costs/baselines?${stringifiedParams}` : `/factories/${factoryId}/operating-costs/baselines`
}

/**
 * Per Cost Line: the baseline version effective at the window's first period (the Baseline columns) and every period in [from, to] resolved — minute-valued time fields, keyed values, the derived third, single-period overrides overlaid and marked, notes. Figures a factory has not keyed itself may derive from an All factories block (derived_fields / derived_from), and parents the factory has no line for arrive as virtual_lines. The window total always equals the baseline; nothing here nets logged time (that is the Cost to Produce reports spec).
 * @summary A group's resolved baselines over a window
 */
export const operatingCostsControllerGetBaselines = async (factoryId: string,
    params: OperatingCostsControllerGetBaselinesParams, options?: Parameters<typeof customFetch>[1]): Promise<operatingCostsControllerGetBaselinesResponse> => {

  return customFetch<operatingCostsControllerGetBaselinesResponse>(getOperatingCostsControllerGetBaselinesUrl(factoryId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOperatingCostsControllerGetBaselinesQueryKey = (factoryId: string,
    params?: OperatingCostsControllerGetBaselinesParams,) => {
    return [
    `/factories/${factoryId}/operating-costs/baselines`, ...(params ? [params] : [])
    ] as const;
    }


export const getOperatingCostsControllerGetBaselinesQueryOptions = <TData = Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError = void>(factoryId: string,
    params: OperatingCostsControllerGetBaselinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperatingCostsControllerGetBaselinesQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>> = ({ signal }) => operatingCostsControllerGetBaselines(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperatingCostsControllerGetBaselinesQueryResult = NonNullable<Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>>
export type OperatingCostsControllerGetBaselinesQueryError = void


export function useOperatingCostsControllerGetBaselines<TData = Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError = void>(
 factoryId: string,
    params: OperatingCostsControllerGetBaselinesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>,
          TError,
          Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatingCostsControllerGetBaselines<TData = Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError = void>(
 factoryId: string,
    params: OperatingCostsControllerGetBaselinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>,
          TError,
          Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatingCostsControllerGetBaselines<TData = Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError = void>(
 factoryId: string,
    params: OperatingCostsControllerGetBaselinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A group's resolved baselines over a window
 */

export function useOperatingCostsControllerGetBaselines<TData = Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError = void>(
 factoryId: string,
    params: OperatingCostsControllerGetBaselinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperatingCostsControllerGetBaselinesQueryOptions(factoryId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary A group's resolved baselines over a window
 */
export const prefetchOperatingCostsControllerGetBaselinesQuery = async <TData = Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError = void>(
 queryClient: QueryClient, factoryId: string,
    params: OperatingCostsControllerGetBaselinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperatingCostsControllerGetBaselinesQueryOptions(factoryId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getOperatingCostsControllerGetBaselinesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError = void>(factoryId: string,
    params: OperatingCostsControllerGetBaselinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperatingCostsControllerGetBaselinesQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>> = ({ signal }) => operatingCostsControllerGetBaselines(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperatingCostsControllerGetBaselinesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>>
export type OperatingCostsControllerGetBaselinesSuspenseQueryError = void


export function useOperatingCostsControllerGetBaselinesSuspense<TData = Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError = void>(
 factoryId: string,
    params: OperatingCostsControllerGetBaselinesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatingCostsControllerGetBaselinesSuspense<TData = Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError = void>(
 factoryId: string,
    params: OperatingCostsControllerGetBaselinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperatingCostsControllerGetBaselinesSuspense<TData = Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError = void>(
 factoryId: string,
    params: OperatingCostsControllerGetBaselinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A group's resolved baselines over a window
 */

export function useOperatingCostsControllerGetBaselinesSuspense<TData = Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError = void>(
 factoryId: string,
    params: OperatingCostsControllerGetBaselinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operatingCostsControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperatingCostsControllerGetBaselinesSuspenseQueryOptions(factoryId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type operatingCostsControllerPutGroupSettingsResponse200 = {
  data: GroupSettingsResponseDto
  status: 200
}

export type operatingCostsControllerPutGroupSettingsResponse404 = {
  data: void
  status: 404
}

export type operatingCostsControllerPutGroupSettingsResponse409 = {
  data: void
  status: 409
}

export type operatingCostsControllerPutGroupSettingsResponseSuccess = (operatingCostsControllerPutGroupSettingsResponse200) & {
  headers: Headers;
};
export type operatingCostsControllerPutGroupSettingsResponseError = (operatingCostsControllerPutGroupSettingsResponse404 | operatingCostsControllerPutGroupSettingsResponse409) & {
  headers: Headers;
};

export type operatingCostsControllerPutGroupSettingsResponse = (operatingCostsControllerPutGroupSettingsResponseSuccess | operatingCostsControllerPutGroupSettingsResponseError)

export const getOperatingCostsControllerPutGroupSettingsUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/operating-costs/settings`
}

/**
 * Week or Month (defaults: Overheads month, Support and Value-adding week). Locked once the group holds any keyed baselines or period figures.
 * @summary Set a Cost Group's baseline period
 */
export const operatingCostsControllerPutGroupSettings = async (factoryId: string,
    putGroupSettingsDto: PutGroupSettingsDto, options?: Parameters<typeof customFetch>[1]): Promise<operatingCostsControllerPutGroupSettingsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<operatingCostsControllerPutGroupSettingsResponse>(getOperatingCostsControllerPutGroupSettingsUrl(factoryId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putGroupSettingsDto)
  }
);}





export const getOperatingCostsControllerPutGroupSettingsMutationKey = () => ['operatingCostsControllerPutGroupSettings'] as const;

export const getOperatingCostsControllerPutGroupSettingsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerPutGroupSettings>>, TError,OperatingCostsControllerPutGroupSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerPutGroupSettings>>, TError,OperatingCostsControllerPutGroupSettingsMutationVariables, TContext> => {

const mutationKey = getOperatingCostsControllerPutGroupSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operatingCostsControllerPutGroupSettings>>, OperatingCostsControllerPutGroupSettingsMutationVariables> = (props) => {
          const {factoryId,data} = props ?? {};

          return  operatingCostsControllerPutGroupSettings(factoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperatingCostsControllerPutGroupSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof operatingCostsControllerPutGroupSettings>>>
    export type OperatingCostsControllerPutGroupSettingsMutationBody = PutGroupSettingsDto
    export type OperatingCostsControllerPutGroupSettingsMutationError = void
    export type OperatingCostsControllerPutGroupSettingsMutationVariables = {factoryId: string;data: PutGroupSettingsDto}

    /**
 * @summary Set a Cost Group's baseline period
 */
export const useOperatingCostsControllerPutGroupSettings = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatingCostsControllerPutGroupSettings>>, TError,OperatingCostsControllerPutGroupSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operatingCostsControllerPutGroupSettings>>,
        TError,
        OperatingCostsControllerPutGroupSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getOperatingCostsControllerPutGroupSettingsMutationOptions(options), queryClient);
    }
    export type allFactoriesBaselinesControllerGetBaselinesResponse200 = {
  data: AllFactoriesBaselinesResponseDto
  status: 200
}

export type allFactoriesBaselinesControllerGetBaselinesResponse400 = {
  data: void
  status: 400
}

export type allFactoriesBaselinesControllerGetBaselinesResponse403 = {
  data: void
  status: 403
}

export type allFactoriesBaselinesControllerGetBaselinesResponse404 = {
  data: void
  status: 404
}

export type allFactoriesBaselinesControllerGetBaselinesResponseSuccess = (allFactoriesBaselinesControllerGetBaselinesResponse200) & {
  headers: Headers;
};
export type allFactoriesBaselinesControllerGetBaselinesResponseError = (allFactoriesBaselinesControllerGetBaselinesResponse400 | allFactoriesBaselinesControllerGetBaselinesResponse403 | allFactoriesBaselinesControllerGetBaselinesResponse404) & {
  headers: Headers;
};

export type allFactoriesBaselinesControllerGetBaselinesResponse = (allFactoriesBaselinesControllerGetBaselinesResponseSuccess | allFactoriesBaselinesControllerGetBaselinesResponseError)

export const getAllFactoriesBaselinesControllerGetBaselinesUrl = (partnerId: string,
    params: AllFactoriesBaselinesControllerGetBaselinesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/partners/${partnerId}/operating-costs/all-factories/baselines?${stringifiedParams}` : `/partners/${partnerId}/operating-costs/all-factories/baselines`
}

/**
 * Per line_key the parent row (keyed block, or the sum of the factories, derived) and one child per active factory (its own keyed figures, or its Shift Minutes share of the block, derived). A cell is keyed or derived, never both; provenance travels with every figure. Period overrides keyed at All factories spread the same way.
 * @summary A group's baselines at All factories: each Cost Line fanned to one row per factory
 */
export const allFactoriesBaselinesControllerGetBaselines = async (partnerId: string,
    params: AllFactoriesBaselinesControllerGetBaselinesParams, options?: Parameters<typeof customFetch>[1]): Promise<allFactoriesBaselinesControllerGetBaselinesResponse> => {

  return customFetch<allFactoriesBaselinesControllerGetBaselinesResponse>(getAllFactoriesBaselinesControllerGetBaselinesUrl(partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAllFactoriesBaselinesControllerGetBaselinesQueryKey = (partnerId: string,
    params?: AllFactoriesBaselinesControllerGetBaselinesParams,) => {
    return [
    `/partners/${partnerId}/operating-costs/all-factories/baselines`, ...(params ? [params] : [])
    ] as const;
    }


export const getAllFactoriesBaselinesControllerGetBaselinesQueryOptions = <TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError = void>(partnerId: string,
    params: AllFactoriesBaselinesControllerGetBaselinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllFactoriesBaselinesControllerGetBaselinesQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>> = ({ signal }) => allFactoriesBaselinesControllerGetBaselines(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AllFactoriesBaselinesControllerGetBaselinesQueryResult = NonNullable<Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>>
export type AllFactoriesBaselinesControllerGetBaselinesQueryError = void


export function useAllFactoriesBaselinesControllerGetBaselines<TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError = void>(
 partnerId: string,
    params: AllFactoriesBaselinesControllerGetBaselinesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>,
          TError,
          Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesBaselinesControllerGetBaselines<TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError = void>(
 partnerId: string,
    params: AllFactoriesBaselinesControllerGetBaselinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>,
          TError,
          Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesBaselinesControllerGetBaselines<TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError = void>(
 partnerId: string,
    params: AllFactoriesBaselinesControllerGetBaselinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A group's baselines at All factories: each Cost Line fanned to one row per factory
 */

export function useAllFactoriesBaselinesControllerGetBaselines<TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError = void>(
 partnerId: string,
    params: AllFactoriesBaselinesControllerGetBaselinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllFactoriesBaselinesControllerGetBaselinesQueryOptions(partnerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary A group's baselines at All factories: each Cost Line fanned to one row per factory
 */
export const prefetchAllFactoriesBaselinesControllerGetBaselinesQuery = async <TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    params: AllFactoriesBaselinesControllerGetBaselinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getAllFactoriesBaselinesControllerGetBaselinesQueryOptions(partnerId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getAllFactoriesBaselinesControllerGetBaselinesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError = void>(partnerId: string,
    params: AllFactoriesBaselinesControllerGetBaselinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllFactoriesBaselinesControllerGetBaselinesQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>> = ({ signal }) => allFactoriesBaselinesControllerGetBaselines(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AllFactoriesBaselinesControllerGetBaselinesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>>
export type AllFactoriesBaselinesControllerGetBaselinesSuspenseQueryError = void


export function useAllFactoriesBaselinesControllerGetBaselinesSuspense<TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError = void>(
 partnerId: string,
    params: AllFactoriesBaselinesControllerGetBaselinesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesBaselinesControllerGetBaselinesSuspense<TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError = void>(
 partnerId: string,
    params: AllFactoriesBaselinesControllerGetBaselinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesBaselinesControllerGetBaselinesSuspense<TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError = void>(
 partnerId: string,
    params: AllFactoriesBaselinesControllerGetBaselinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A group's baselines at All factories: each Cost Line fanned to one row per factory
 */

export function useAllFactoriesBaselinesControllerGetBaselinesSuspense<TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError = void>(
 partnerId: string,
    params: AllFactoriesBaselinesControllerGetBaselinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerGetBaselines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllFactoriesBaselinesControllerGetBaselinesSuspenseQueryOptions(partnerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type allFactoriesBaselinesControllerListAvailableCostLinesResponse200 = {
  data: AvailableCostLinesResponseDto
  status: 200
}

export type allFactoriesBaselinesControllerListAvailableCostLinesResponse400 = {
  data: void
  status: 400
}

export type allFactoriesBaselinesControllerListAvailableCostLinesResponse403 = {
  data: void
  status: 403
}

export type allFactoriesBaselinesControllerListAvailableCostLinesResponse404 = {
  data: void
  status: 404
}

export type allFactoriesBaselinesControllerListAvailableCostLinesResponseSuccess = (allFactoriesBaselinesControllerListAvailableCostLinesResponse200) & {
  headers: Headers;
};
export type allFactoriesBaselinesControllerListAvailableCostLinesResponseError = (allFactoriesBaselinesControllerListAvailableCostLinesResponse400 | allFactoriesBaselinesControllerListAvailableCostLinesResponse403 | allFactoriesBaselinesControllerListAvailableCostLinesResponse404) & {
  headers: Headers;
};

export type allFactoriesBaselinesControllerListAvailableCostLinesResponse = (allFactoriesBaselinesControllerListAvailableCostLinesResponseSuccess | allFactoriesBaselinesControllerListAvailableCostLinesResponseError)

export const getAllFactoriesBaselinesControllerListAvailableCostLinesUrl = (partnerId: string,
    params: AllFactoriesBaselinesControllerListAvailableCostLinesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/partners/${partnerId}/operating-costs/all-factories/available-cost-lines?${stringifiedParams}` : `/partners/${partnerId}/operating-costs/all-factories/available-cost-lines`
}

/**
 * Every Cost Category of the group (predefined, then the partner's own types) and, for Value-adding, every operation, with no active All factories parent and no active line in any factory. A row whose parent is archived carries archived_line_id — unarchive it instead of adding a second.
 * @summary The Cost Lines All factories has not enabled yet
 */
export const allFactoriesBaselinesControllerListAvailableCostLines = async (partnerId: string,
    params: AllFactoriesBaselinesControllerListAvailableCostLinesParams, options?: Parameters<typeof customFetch>[1]): Promise<allFactoriesBaselinesControllerListAvailableCostLinesResponse> => {

  return customFetch<allFactoriesBaselinesControllerListAvailableCostLinesResponse>(getAllFactoriesBaselinesControllerListAvailableCostLinesUrl(partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAllFactoriesBaselinesControllerListAvailableCostLinesQueryKey = (partnerId: string,
    params?: AllFactoriesBaselinesControllerListAvailableCostLinesParams,) => {
    return [
    `/partners/${partnerId}/operating-costs/all-factories/available-cost-lines`, ...(params ? [params] : [])
    ] as const;
    }


export const getAllFactoriesBaselinesControllerListAvailableCostLinesQueryOptions = <TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError = void>(partnerId: string,
    params: AllFactoriesBaselinesControllerListAvailableCostLinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllFactoriesBaselinesControllerListAvailableCostLinesQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>> = ({ signal }) => allFactoriesBaselinesControllerListAvailableCostLines(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AllFactoriesBaselinesControllerListAvailableCostLinesQueryResult = NonNullable<Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>>
export type AllFactoriesBaselinesControllerListAvailableCostLinesQueryError = void


export function useAllFactoriesBaselinesControllerListAvailableCostLines<TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError = void>(
 partnerId: string,
    params: AllFactoriesBaselinesControllerListAvailableCostLinesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>,
          TError,
          Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesBaselinesControllerListAvailableCostLines<TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError = void>(
 partnerId: string,
    params: AllFactoriesBaselinesControllerListAvailableCostLinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>,
          TError,
          Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesBaselinesControllerListAvailableCostLines<TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError = void>(
 partnerId: string,
    params: AllFactoriesBaselinesControllerListAvailableCostLinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The Cost Lines All factories has not enabled yet
 */

export function useAllFactoriesBaselinesControllerListAvailableCostLines<TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError = void>(
 partnerId: string,
    params: AllFactoriesBaselinesControllerListAvailableCostLinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllFactoriesBaselinesControllerListAvailableCostLinesQueryOptions(partnerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary The Cost Lines All factories has not enabled yet
 */
export const prefetchAllFactoriesBaselinesControllerListAvailableCostLinesQuery = async <TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    params: AllFactoriesBaselinesControllerListAvailableCostLinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getAllFactoriesBaselinesControllerListAvailableCostLinesQueryOptions(partnerId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getAllFactoriesBaselinesControllerListAvailableCostLinesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError = void>(partnerId: string,
    params: AllFactoriesBaselinesControllerListAvailableCostLinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllFactoriesBaselinesControllerListAvailableCostLinesQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>> = ({ signal }) => allFactoriesBaselinesControllerListAvailableCostLines(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AllFactoriesBaselinesControllerListAvailableCostLinesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>>
export type AllFactoriesBaselinesControllerListAvailableCostLinesSuspenseQueryError = void


export function useAllFactoriesBaselinesControllerListAvailableCostLinesSuspense<TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError = void>(
 partnerId: string,
    params: AllFactoriesBaselinesControllerListAvailableCostLinesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesBaselinesControllerListAvailableCostLinesSuspense<TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError = void>(
 partnerId: string,
    params: AllFactoriesBaselinesControllerListAvailableCostLinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesBaselinesControllerListAvailableCostLinesSuspense<TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError = void>(
 partnerId: string,
    params: AllFactoriesBaselinesControllerListAvailableCostLinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The Cost Lines All factories has not enabled yet
 */

export function useAllFactoriesBaselinesControllerListAvailableCostLinesSuspense<TData = Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError = void>(
 partnerId: string,
    params: AllFactoriesBaselinesControllerListAvailableCostLinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerListAvailableCostLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllFactoriesBaselinesControllerListAvailableCostLinesSuspenseQueryOptions(partnerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type allFactoriesBaselinesControllerCreateLineResponse201 = {
  data: CostLineDto
  status: 201
}

export type allFactoriesBaselinesControllerCreateLineResponse400 = {
  data: void
  status: 400
}

export type allFactoriesBaselinesControllerCreateLineResponse403 = {
  data: void
  status: 403
}

export type allFactoriesBaselinesControllerCreateLineResponse404 = {
  data: void
  status: 404
}

export type allFactoriesBaselinesControllerCreateLineResponse409 = {
  data: void
  status: 409
}

export type allFactoriesBaselinesControllerCreateLineResponse422 = {
  data: void
  status: 422
}

export type allFactoriesBaselinesControllerCreateLineResponseSuccess = (allFactoriesBaselinesControllerCreateLineResponse201) & {
  headers: Headers;
};
export type allFactoriesBaselinesControllerCreateLineResponseError = (allFactoriesBaselinesControllerCreateLineResponse400 | allFactoriesBaselinesControllerCreateLineResponse403 | allFactoriesBaselinesControllerCreateLineResponse404 | allFactoriesBaselinesControllerCreateLineResponse409 | allFactoriesBaselinesControllerCreateLineResponse422) & {
  headers: Headers;
};

export type allFactoriesBaselinesControllerCreateLineResponse = (allFactoriesBaselinesControllerCreateLineResponseSuccess | allFactoriesBaselinesControllerCreateLineResponseError)

export const getAllFactoriesBaselinesControllerCreateLineUrl = (partnerId: string,) => {




  return `/partners/${partnerId}/operating-costs/all-factories/lines`
}

/**
 * A partner-level line that every factory is a child of. One per Cost Category (or operation), archived included — unarchive instead of adding a second.
 * @summary Add an All factories Cost Line
 */
export const allFactoriesBaselinesControllerCreateLine = async (partnerId: string,
    createCostLineDto: CreateCostLineDto, options?: Parameters<typeof customFetch>[1]): Promise<allFactoriesBaselinesControllerCreateLineResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<allFactoriesBaselinesControllerCreateLineResponse>(getAllFactoriesBaselinesControllerCreateLineUrl(partnerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCostLineDto)
  }
);}





export const getAllFactoriesBaselinesControllerCreateLineMutationKey = () => ['allFactoriesBaselinesControllerCreateLine'] as const;

export const getAllFactoriesBaselinesControllerCreateLineMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerCreateLine>>, TError,AllFactoriesBaselinesControllerCreateLineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerCreateLine>>, TError,AllFactoriesBaselinesControllerCreateLineMutationVariables, TContext> => {

const mutationKey = getAllFactoriesBaselinesControllerCreateLineMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allFactoriesBaselinesControllerCreateLine>>, AllFactoriesBaselinesControllerCreateLineMutationVariables> = (props) => {
          const {partnerId,data} = props ?? {};

          return  allFactoriesBaselinesControllerCreateLine(partnerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllFactoriesBaselinesControllerCreateLineMutationResult = NonNullable<Awaited<ReturnType<typeof allFactoriesBaselinesControllerCreateLine>>>
    export type AllFactoriesBaselinesControllerCreateLineMutationBody = CreateCostLineDto
    export type AllFactoriesBaselinesControllerCreateLineMutationError = void
    export type AllFactoriesBaselinesControllerCreateLineMutationVariables = {partnerId: string;data: CreateCostLineDto}

    /**
 * @summary Add an All factories Cost Line
 */
export const useAllFactoriesBaselinesControllerCreateLine = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerCreateLine>>, TError,AllFactoriesBaselinesControllerCreateLineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allFactoriesBaselinesControllerCreateLine>>,
        TError,
        AllFactoriesBaselinesControllerCreateLineMutationVariables,
        TContext
      > => {
      return useMutation(getAllFactoriesBaselinesControllerCreateLineMutationOptions(options), queryClient);
    }
    export type allFactoriesBaselinesControllerUpdateLineResponse200 = {
  data: CostLineDto
  status: 200
}

export type allFactoriesBaselinesControllerUpdateLineResponse403 = {
  data: void
  status: 403
}

export type allFactoriesBaselinesControllerUpdateLineResponse404 = {
  data: void
  status: 404
}

export type allFactoriesBaselinesControllerUpdateLineResponse409 = {
  data: void
  status: 409
}

export type allFactoriesBaselinesControllerUpdateLineResponseSuccess = (allFactoriesBaselinesControllerUpdateLineResponse200) & {
  headers: Headers;
};
export type allFactoriesBaselinesControllerUpdateLineResponseError = (allFactoriesBaselinesControllerUpdateLineResponse403 | allFactoriesBaselinesControllerUpdateLineResponse404 | allFactoriesBaselinesControllerUpdateLineResponse409) & {
  headers: Headers;
};

export type allFactoriesBaselinesControllerUpdateLineResponse = (allFactoriesBaselinesControllerUpdateLineResponseSuccess | allFactoriesBaselinesControllerUpdateLineResponseError)

export const getAllFactoriesBaselinesControllerUpdateLineUrl = (partnerId: string,
    costLineId: string,) => {




  return `/partners/${partnerId}/operating-costs/all-factories/lines/${costLineId}`
}

/**
 * @summary Rename an All factories Cost Line or set its Cost Code
 */
export const allFactoriesBaselinesControllerUpdateLine = async (partnerId: string,
    costLineId: string,
    updateCostLineDto: UpdateCostLineDto, options?: Parameters<typeof customFetch>[1]): Promise<allFactoriesBaselinesControllerUpdateLineResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<allFactoriesBaselinesControllerUpdateLineResponse>(getAllFactoriesBaselinesControllerUpdateLineUrl(partnerId,costLineId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateCostLineDto)
  }
);}





export const getAllFactoriesBaselinesControllerUpdateLineMutationKey = () => ['allFactoriesBaselinesControllerUpdateLine'] as const;

export const getAllFactoriesBaselinesControllerUpdateLineMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerUpdateLine>>, TError,AllFactoriesBaselinesControllerUpdateLineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerUpdateLine>>, TError,AllFactoriesBaselinesControllerUpdateLineMutationVariables, TContext> => {

const mutationKey = getAllFactoriesBaselinesControllerUpdateLineMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allFactoriesBaselinesControllerUpdateLine>>, AllFactoriesBaselinesControllerUpdateLineMutationVariables> = (props) => {
          const {partnerId,costLineId,data} = props ?? {};

          return  allFactoriesBaselinesControllerUpdateLine(partnerId,costLineId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllFactoriesBaselinesControllerUpdateLineMutationResult = NonNullable<Awaited<ReturnType<typeof allFactoriesBaselinesControllerUpdateLine>>>
    export type AllFactoriesBaselinesControllerUpdateLineMutationBody = UpdateCostLineDto
    export type AllFactoriesBaselinesControllerUpdateLineMutationError = void
    export type AllFactoriesBaselinesControllerUpdateLineMutationVariables = {partnerId: string;costLineId: string;data: UpdateCostLineDto}

    /**
 * @summary Rename an All factories Cost Line or set its Cost Code
 */
export const useAllFactoriesBaselinesControllerUpdateLine = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerUpdateLine>>, TError,AllFactoriesBaselinesControllerUpdateLineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allFactoriesBaselinesControllerUpdateLine>>,
        TError,
        AllFactoriesBaselinesControllerUpdateLineMutationVariables,
        TContext
      > => {
      return useMutation(getAllFactoriesBaselinesControllerUpdateLineMutationOptions(options), queryClient);
    }
    export type allFactoriesBaselinesControllerArchiveLineResponse200 = {
  data: CostLineDto
  status: 200
}

export type allFactoriesBaselinesControllerArchiveLineResponse403 = {
  data: void
  status: 403
}

export type allFactoriesBaselinesControllerArchiveLineResponse404 = {
  data: void
  status: 404
}

export type allFactoriesBaselinesControllerArchiveLineResponseSuccess = (allFactoriesBaselinesControllerArchiveLineResponse200) & {
  headers: Headers;
};
export type allFactoriesBaselinesControllerArchiveLineResponseError = (allFactoriesBaselinesControllerArchiveLineResponse403 | allFactoriesBaselinesControllerArchiveLineResponse404) & {
  headers: Headers;
};

export type allFactoriesBaselinesControllerArchiveLineResponse = (allFactoriesBaselinesControllerArchiveLineResponseSuccess | allFactoriesBaselinesControllerArchiveLineResponseError)

export const getAllFactoriesBaselinesControllerArchiveLineUrl = (partnerId: string,
    costLineId: string,) => {




  return `/partners/${partnerId}/operating-costs/all-factories/lines/${costLineId}/archive`
}

/**
 * Its block stops spreading; every factory keeps the figures it keyed itself.
 * @summary Archive an All factories Cost Line
 */
export const allFactoriesBaselinesControllerArchiveLine = async (partnerId: string,
    costLineId: string, options?: Parameters<typeof customFetch>[1]): Promise<allFactoriesBaselinesControllerArchiveLineResponse> => {

  return customFetch<allFactoriesBaselinesControllerArchiveLineResponse>(getAllFactoriesBaselinesControllerArchiveLineUrl(partnerId,costLineId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAllFactoriesBaselinesControllerArchiveLineMutationKey = () => ['allFactoriesBaselinesControllerArchiveLine'] as const;

export const getAllFactoriesBaselinesControllerArchiveLineMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerArchiveLine>>, TError,AllFactoriesBaselinesControllerArchiveLineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerArchiveLine>>, TError,AllFactoriesBaselinesControllerArchiveLineMutationVariables, TContext> => {

const mutationKey = getAllFactoriesBaselinesControllerArchiveLineMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allFactoriesBaselinesControllerArchiveLine>>, AllFactoriesBaselinesControllerArchiveLineMutationVariables> = (props) => {
          const {partnerId,costLineId} = props ?? {};

          return  allFactoriesBaselinesControllerArchiveLine(partnerId,costLineId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllFactoriesBaselinesControllerArchiveLineMutationResult = NonNullable<Awaited<ReturnType<typeof allFactoriesBaselinesControllerArchiveLine>>>

    export type AllFactoriesBaselinesControllerArchiveLineMutationError = void
    export type AllFactoriesBaselinesControllerArchiveLineMutationVariables = {partnerId: string;costLineId: string}

    /**
 * @summary Archive an All factories Cost Line
 */
export const useAllFactoriesBaselinesControllerArchiveLine = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerArchiveLine>>, TError,AllFactoriesBaselinesControllerArchiveLineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allFactoriesBaselinesControllerArchiveLine>>,
        TError,
        AllFactoriesBaselinesControllerArchiveLineMutationVariables,
        TContext
      > => {
      return useMutation(getAllFactoriesBaselinesControllerArchiveLineMutationOptions(options), queryClient);
    }
    export type allFactoriesBaselinesControllerUnarchiveLineResponse200 = {
  data: CostLineDto
  status: 200
}

export type allFactoriesBaselinesControllerUnarchiveLineResponse403 = {
  data: void
  status: 403
}

export type allFactoriesBaselinesControllerUnarchiveLineResponse404 = {
  data: void
  status: 404
}

export type allFactoriesBaselinesControllerUnarchiveLineResponseSuccess = (allFactoriesBaselinesControllerUnarchiveLineResponse200) & {
  headers: Headers;
};
export type allFactoriesBaselinesControllerUnarchiveLineResponseError = (allFactoriesBaselinesControllerUnarchiveLineResponse403 | allFactoriesBaselinesControllerUnarchiveLineResponse404) & {
  headers: Headers;
};

export type allFactoriesBaselinesControllerUnarchiveLineResponse = (allFactoriesBaselinesControllerUnarchiveLineResponseSuccess | allFactoriesBaselinesControllerUnarchiveLineResponseError)

export const getAllFactoriesBaselinesControllerUnarchiveLineUrl = (partnerId: string,
    costLineId: string,) => {




  return `/partners/${partnerId}/operating-costs/all-factories/lines/${costLineId}/unarchive`
}

/**
 * @summary Unarchive an All factories Cost Line
 */
export const allFactoriesBaselinesControllerUnarchiveLine = async (partnerId: string,
    costLineId: string, options?: Parameters<typeof customFetch>[1]): Promise<allFactoriesBaselinesControllerUnarchiveLineResponse> => {

  return customFetch<allFactoriesBaselinesControllerUnarchiveLineResponse>(getAllFactoriesBaselinesControllerUnarchiveLineUrl(partnerId,costLineId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAllFactoriesBaselinesControllerUnarchiveLineMutationKey = () => ['allFactoriesBaselinesControllerUnarchiveLine'] as const;

export const getAllFactoriesBaselinesControllerUnarchiveLineMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerUnarchiveLine>>, TError,AllFactoriesBaselinesControllerUnarchiveLineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerUnarchiveLine>>, TError,AllFactoriesBaselinesControllerUnarchiveLineMutationVariables, TContext> => {

const mutationKey = getAllFactoriesBaselinesControllerUnarchiveLineMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allFactoriesBaselinesControllerUnarchiveLine>>, AllFactoriesBaselinesControllerUnarchiveLineMutationVariables> = (props) => {
          const {partnerId,costLineId} = props ?? {};

          return  allFactoriesBaselinesControllerUnarchiveLine(partnerId,costLineId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllFactoriesBaselinesControllerUnarchiveLineMutationResult = NonNullable<Awaited<ReturnType<typeof allFactoriesBaselinesControllerUnarchiveLine>>>

    export type AllFactoriesBaselinesControllerUnarchiveLineMutationError = void
    export type AllFactoriesBaselinesControllerUnarchiveLineMutationVariables = {partnerId: string;costLineId: string}

    /**
 * @summary Unarchive an All factories Cost Line
 */
export const useAllFactoriesBaselinesControllerUnarchiveLine = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerUnarchiveLine>>, TError,AllFactoriesBaselinesControllerUnarchiveLineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allFactoriesBaselinesControllerUnarchiveLine>>,
        TError,
        AllFactoriesBaselinesControllerUnarchiveLineMutationVariables,
        TContext
      > => {
      return useMutation(getAllFactoriesBaselinesControllerUnarchiveLineMutationOptions(options), queryClient);
    }
    export type allFactoriesBaselinesControllerPutParentBaselineResponse200 = {
  data: BaselineVersionDto
  status: 200
}

export type allFactoriesBaselinesControllerPutParentBaselineResponse400 = {
  data: void
  status: 400
}

export type allFactoriesBaselinesControllerPutParentBaselineResponse403 = {
  data: void
  status: 403
}

export type allFactoriesBaselinesControllerPutParentBaselineResponse404 = {
  data: void
  status: 404
}

export type allFactoriesBaselinesControllerPutParentBaselineResponse409 = {
  data: void
  status: 409
}

export type allFactoriesBaselinesControllerPutParentBaselineResponse422 = {
  data: void
  status: 422
}

export type allFactoriesBaselinesControllerPutParentBaselineResponseSuccess = (allFactoriesBaselinesControllerPutParentBaselineResponse200) & {
  headers: Headers;
};
export type allFactoriesBaselinesControllerPutParentBaselineResponseError = (allFactoriesBaselinesControllerPutParentBaselineResponse400 | allFactoriesBaselinesControllerPutParentBaselineResponse403 | allFactoriesBaselinesControllerPutParentBaselineResponse404 | allFactoriesBaselinesControllerPutParentBaselineResponse409 | allFactoriesBaselinesControllerPutParentBaselineResponse422) & {
  headers: Headers;
};

export type allFactoriesBaselinesControllerPutParentBaselineResponse = (allFactoriesBaselinesControllerPutParentBaselineResponseSuccess | allFactoriesBaselinesControllerPutParentBaselineResponseError)

export const getAllFactoriesBaselinesControllerPutParentBaselineUrl = (partnerId: string,
    costGroup: string,
    lineKey: string,) => {




  return `/partners/${partnerId}/operating-costs/all-factories/${costGroup}/lines/${lineKey}/baseline`
}

/**
 * Creates the All factories line for this line_key if none exists yet, then appends a baseline version. Overheads key cost only. Support and Value-adding key ONE quantity — minutes or cost — plus a rate: the quantity spreads to the factories by Shift Minutes, the rate is copied to each. An all-null payload clears the block from that period onward.
 * @summary Key an All factories baseline from a period onward
 */
export const allFactoriesBaselinesControllerPutParentBaseline = async (partnerId: string,
    costGroup: string,
    lineKey: string,
    putBaselineDto: PutBaselineDto, options?: Parameters<typeof customFetch>[1]): Promise<allFactoriesBaselinesControllerPutParentBaselineResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<allFactoriesBaselinesControllerPutParentBaselineResponse>(getAllFactoriesBaselinesControllerPutParentBaselineUrl(partnerId,costGroup,lineKey),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putBaselineDto)
  }
);}





export const getAllFactoriesBaselinesControllerPutParentBaselineMutationKey = () => ['allFactoriesBaselinesControllerPutParentBaseline'] as const;

export const getAllFactoriesBaselinesControllerPutParentBaselineMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutParentBaseline>>, TError,AllFactoriesBaselinesControllerPutParentBaselineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutParentBaseline>>, TError,AllFactoriesBaselinesControllerPutParentBaselineMutationVariables, TContext> => {

const mutationKey = getAllFactoriesBaselinesControllerPutParentBaselineMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutParentBaseline>>, AllFactoriesBaselinesControllerPutParentBaselineMutationVariables> = (props) => {
          const {partnerId,costGroup,lineKey,data} = props ?? {};

          return  allFactoriesBaselinesControllerPutParentBaseline(partnerId,costGroup,lineKey,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllFactoriesBaselinesControllerPutParentBaselineMutationResult = NonNullable<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutParentBaseline>>>
    export type AllFactoriesBaselinesControllerPutParentBaselineMutationBody = PutBaselineDto
    export type AllFactoriesBaselinesControllerPutParentBaselineMutationError = void
    export type AllFactoriesBaselinesControllerPutParentBaselineMutationVariables = {partnerId: string;costGroup: string;lineKey: string;data: PutBaselineDto}

    /**
 * @summary Key an All factories baseline from a period onward
 */
export const useAllFactoriesBaselinesControllerPutParentBaseline = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutParentBaseline>>, TError,AllFactoriesBaselinesControllerPutParentBaselineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutParentBaseline>>,
        TError,
        AllFactoriesBaselinesControllerPutParentBaselineMutationVariables,
        TContext
      > => {
      return useMutation(getAllFactoriesBaselinesControllerPutParentBaselineMutationOptions(options), queryClient);
    }
    export type allFactoriesBaselinesControllerPutParentPeriodValueResponse200 = {
  data: PeriodValueResponseDto
  status: 200
}

export type allFactoriesBaselinesControllerPutParentPeriodValueResponse400 = {
  data: void
  status: 400
}

export type allFactoriesBaselinesControllerPutParentPeriodValueResponse403 = {
  data: void
  status: 403
}

export type allFactoriesBaselinesControllerPutParentPeriodValueResponse404 = {
  data: void
  status: 404
}

export type allFactoriesBaselinesControllerPutParentPeriodValueResponse409 = {
  data: void
  status: 409
}

export type allFactoriesBaselinesControllerPutParentPeriodValueResponse422 = {
  data: void
  status: 422
}

export type allFactoriesBaselinesControllerPutParentPeriodValueResponseSuccess = (allFactoriesBaselinesControllerPutParentPeriodValueResponse200) & {
  headers: Headers;
};
export type allFactoriesBaselinesControllerPutParentPeriodValueResponseError = (allFactoriesBaselinesControllerPutParentPeriodValueResponse400 | allFactoriesBaselinesControllerPutParentPeriodValueResponse403 | allFactoriesBaselinesControllerPutParentPeriodValueResponse404 | allFactoriesBaselinesControllerPutParentPeriodValueResponse409 | allFactoriesBaselinesControllerPutParentPeriodValueResponse422) & {
  headers: Headers;
};

export type allFactoriesBaselinesControllerPutParentPeriodValueResponse = (allFactoriesBaselinesControllerPutParentPeriodValueResponseSuccess | allFactoriesBaselinesControllerPutParentPeriodValueResponseError)

export const getAllFactoriesBaselinesControllerPutParentPeriodValueUrl = (partnerId: string,
    costGroup: string,
    lineKey: string,
    periodStart: string,) => {




  return `/partners/${partnerId}/operating-costs/all-factories/${costGroup}/lines/${lineKey}/periods/${periodStart}`
}

/**
 * Edits that period of the block alone; the override spreads to the factories the same way the block does. Per field: absent = unchanged, null = cleared.
 * @summary Override one period's All factories figure, or set its note
 */
export const allFactoriesBaselinesControllerPutParentPeriodValue = async (partnerId: string,
    costGroup: string,
    lineKey: string,
    periodStart: string,
    putPeriodValueDto: PutPeriodValueDto, options?: Parameters<typeof customFetch>[1]): Promise<allFactoriesBaselinesControllerPutParentPeriodValueResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<allFactoriesBaselinesControllerPutParentPeriodValueResponse>(getAllFactoriesBaselinesControllerPutParentPeriodValueUrl(partnerId,costGroup,lineKey,periodStart),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putPeriodValueDto)
  }
);}





export const getAllFactoriesBaselinesControllerPutParentPeriodValueMutationKey = () => ['allFactoriesBaselinesControllerPutParentPeriodValue'] as const;

export const getAllFactoriesBaselinesControllerPutParentPeriodValueMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutParentPeriodValue>>, TError,AllFactoriesBaselinesControllerPutParentPeriodValueMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutParentPeriodValue>>, TError,AllFactoriesBaselinesControllerPutParentPeriodValueMutationVariables, TContext> => {

const mutationKey = getAllFactoriesBaselinesControllerPutParentPeriodValueMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutParentPeriodValue>>, AllFactoriesBaselinesControllerPutParentPeriodValueMutationVariables> = (props) => {
          const {partnerId,costGroup,lineKey,periodStart,data} = props ?? {};

          return  allFactoriesBaselinesControllerPutParentPeriodValue(partnerId,costGroup,lineKey,periodStart,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllFactoriesBaselinesControllerPutParentPeriodValueMutationResult = NonNullable<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutParentPeriodValue>>>
    export type AllFactoriesBaselinesControllerPutParentPeriodValueMutationBody = PutPeriodValueDto
    export type AllFactoriesBaselinesControllerPutParentPeriodValueMutationError = void
    export type AllFactoriesBaselinesControllerPutParentPeriodValueMutationVariables = {partnerId: string;costGroup: string;lineKey: string;periodStart: string;data: PutPeriodValueDto}

    /**
 * @summary Override one period's All factories figure, or set its note
 */
export const useAllFactoriesBaselinesControllerPutParentPeriodValue = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutParentPeriodValue>>, TError,AllFactoriesBaselinesControllerPutParentPeriodValueMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutParentPeriodValue>>,
        TError,
        AllFactoriesBaselinesControllerPutParentPeriodValueMutationVariables,
        TContext
      > => {
      return useMutation(getAllFactoriesBaselinesControllerPutParentPeriodValueMutationOptions(options), queryClient);
    }
    export type allFactoriesBaselinesControllerPutChildBaselineResponse200 = {
  data: BaselineVersionDto
  status: 200
}

export type allFactoriesBaselinesControllerPutChildBaselineResponse400 = {
  data: void
  status: 400
}

export type allFactoriesBaselinesControllerPutChildBaselineResponse403 = {
  data: void
  status: 403
}

export type allFactoriesBaselinesControllerPutChildBaselineResponse404 = {
  data: void
  status: 404
}

export type allFactoriesBaselinesControllerPutChildBaselineResponse409 = {
  data: void
  status: 409
}

export type allFactoriesBaselinesControllerPutChildBaselineResponse422 = {
  data: void
  status: 422
}

export type allFactoriesBaselinesControllerPutChildBaselineResponseSuccess = (allFactoriesBaselinesControllerPutChildBaselineResponse200) & {
  headers: Headers;
};
export type allFactoriesBaselinesControllerPutChildBaselineResponseError = (allFactoriesBaselinesControllerPutChildBaselineResponse400 | allFactoriesBaselinesControllerPutChildBaselineResponse403 | allFactoriesBaselinesControllerPutChildBaselineResponse404 | allFactoriesBaselinesControllerPutChildBaselineResponse409 | allFactoriesBaselinesControllerPutChildBaselineResponse422) & {
  headers: Headers;
};

export type allFactoriesBaselinesControllerPutChildBaselineResponse = (allFactoriesBaselinesControllerPutChildBaselineResponseSuccess | allFactoriesBaselinesControllerPutChildBaselineResponseError)

export const getAllFactoriesBaselinesControllerPutChildBaselineUrl = (partnerId: string,
    costGroup: string,
    lineKey: string,
    factoryId: string,) => {




  return `/partners/${partnerId}/operating-costs/all-factories/${costGroup}/lines/${lineKey}/factories/${factoryId}/baseline`
}

/**
 * Keys the factory's own line for this line_key (creating it, named after the parent, when the factory has none), so a derived share becomes a keyed figure. An all-null payload clears it and the factory derives again.
 * @summary Key one factory's baseline under an All factories line
 */
export const allFactoriesBaselinesControllerPutChildBaseline = async (partnerId: string,
    costGroup: string,
    lineKey: string,
    factoryId: string,
    putBaselineDto: PutBaselineDto, options?: Parameters<typeof customFetch>[1]): Promise<allFactoriesBaselinesControllerPutChildBaselineResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<allFactoriesBaselinesControllerPutChildBaselineResponse>(getAllFactoriesBaselinesControllerPutChildBaselineUrl(partnerId,costGroup,lineKey,factoryId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putBaselineDto)
  }
);}





export const getAllFactoriesBaselinesControllerPutChildBaselineMutationKey = () => ['allFactoriesBaselinesControllerPutChildBaseline'] as const;

export const getAllFactoriesBaselinesControllerPutChildBaselineMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutChildBaseline>>, TError,AllFactoriesBaselinesControllerPutChildBaselineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutChildBaseline>>, TError,AllFactoriesBaselinesControllerPutChildBaselineMutationVariables, TContext> => {

const mutationKey = getAllFactoriesBaselinesControllerPutChildBaselineMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutChildBaseline>>, AllFactoriesBaselinesControllerPutChildBaselineMutationVariables> = (props) => {
          const {partnerId,costGroup,lineKey,factoryId,data} = props ?? {};

          return  allFactoriesBaselinesControllerPutChildBaseline(partnerId,costGroup,lineKey,factoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllFactoriesBaselinesControllerPutChildBaselineMutationResult = NonNullable<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutChildBaseline>>>
    export type AllFactoriesBaselinesControllerPutChildBaselineMutationBody = PutBaselineDto
    export type AllFactoriesBaselinesControllerPutChildBaselineMutationError = void
    export type AllFactoriesBaselinesControllerPutChildBaselineMutationVariables = {partnerId: string;costGroup: string;lineKey: string;factoryId: string;data: PutBaselineDto}

    /**
 * @summary Key one factory's baseline under an All factories line
 */
export const useAllFactoriesBaselinesControllerPutChildBaseline = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutChildBaseline>>, TError,AllFactoriesBaselinesControllerPutChildBaselineMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutChildBaseline>>,
        TError,
        AllFactoriesBaselinesControllerPutChildBaselineMutationVariables,
        TContext
      > => {
      return useMutation(getAllFactoriesBaselinesControllerPutChildBaselineMutationOptions(options), queryClient);
    }
    export type allFactoriesBaselinesControllerPutChildPeriodValueResponse200 = {
  data: PeriodValueResponseDto
  status: 200
}

export type allFactoriesBaselinesControllerPutChildPeriodValueResponse400 = {
  data: void
  status: 400
}

export type allFactoriesBaselinesControllerPutChildPeriodValueResponse403 = {
  data: void
  status: 403
}

export type allFactoriesBaselinesControllerPutChildPeriodValueResponse404 = {
  data: void
  status: 404
}

export type allFactoriesBaselinesControllerPutChildPeriodValueResponse409 = {
  data: void
  status: 409
}

export type allFactoriesBaselinesControllerPutChildPeriodValueResponse422 = {
  data: void
  status: 422
}

export type allFactoriesBaselinesControllerPutChildPeriodValueResponseSuccess = (allFactoriesBaselinesControllerPutChildPeriodValueResponse200) & {
  headers: Headers;
};
export type allFactoriesBaselinesControllerPutChildPeriodValueResponseError = (allFactoriesBaselinesControllerPutChildPeriodValueResponse400 | allFactoriesBaselinesControllerPutChildPeriodValueResponse403 | allFactoriesBaselinesControllerPutChildPeriodValueResponse404 | allFactoriesBaselinesControllerPutChildPeriodValueResponse409 | allFactoriesBaselinesControllerPutChildPeriodValueResponse422) & {
  headers: Headers;
};

export type allFactoriesBaselinesControllerPutChildPeriodValueResponse = (allFactoriesBaselinesControllerPutChildPeriodValueResponseSuccess | allFactoriesBaselinesControllerPutChildPeriodValueResponseError)

export const getAllFactoriesBaselinesControllerPutChildPeriodValueUrl = (partnerId: string,
    costGroup: string,
    lineKey: string,
    factoryId: string,
    periodStart: string,) => {




  return `/partners/${partnerId}/operating-costs/all-factories/${costGroup}/lines/${lineKey}/factories/${factoryId}/periods/${periodStart}`
}

/**
 * Edits that factory's period alone (creating the factory's line first when it has none). The override lands on what the factory's line keys.
 * @summary Override one period of one factory's figure under an All factories line
 */
export const allFactoriesBaselinesControllerPutChildPeriodValue = async (partnerId: string,
    costGroup: string,
    lineKey: string,
    factoryId: string,
    periodStart: string,
    putPeriodValueDto: PutPeriodValueDto, options?: Parameters<typeof customFetch>[1]): Promise<allFactoriesBaselinesControllerPutChildPeriodValueResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<allFactoriesBaselinesControllerPutChildPeriodValueResponse>(getAllFactoriesBaselinesControllerPutChildPeriodValueUrl(partnerId,costGroup,lineKey,factoryId,periodStart),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putPeriodValueDto)
  }
);}





export const getAllFactoriesBaselinesControllerPutChildPeriodValueMutationKey = () => ['allFactoriesBaselinesControllerPutChildPeriodValue'] as const;

export const getAllFactoriesBaselinesControllerPutChildPeriodValueMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutChildPeriodValue>>, TError,AllFactoriesBaselinesControllerPutChildPeriodValueMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutChildPeriodValue>>, TError,AllFactoriesBaselinesControllerPutChildPeriodValueMutationVariables, TContext> => {

const mutationKey = getAllFactoriesBaselinesControllerPutChildPeriodValueMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutChildPeriodValue>>, AllFactoriesBaselinesControllerPutChildPeriodValueMutationVariables> = (props) => {
          const {partnerId,costGroup,lineKey,factoryId,periodStart,data} = props ?? {};

          return  allFactoriesBaselinesControllerPutChildPeriodValue(partnerId,costGroup,lineKey,factoryId,periodStart,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllFactoriesBaselinesControllerPutChildPeriodValueMutationResult = NonNullable<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutChildPeriodValue>>>
    export type AllFactoriesBaselinesControllerPutChildPeriodValueMutationBody = PutPeriodValueDto
    export type AllFactoriesBaselinesControllerPutChildPeriodValueMutationError = void
    export type AllFactoriesBaselinesControllerPutChildPeriodValueMutationVariables = {partnerId: string;costGroup: string;lineKey: string;factoryId: string;periodStart: string;data: PutPeriodValueDto}

    /**
 * @summary Override one period of one factory's figure under an All factories line
 */
export const useAllFactoriesBaselinesControllerPutChildPeriodValue = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutChildPeriodValue>>, TError,AllFactoriesBaselinesControllerPutChildPeriodValueMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allFactoriesBaselinesControllerPutChildPeriodValue>>,
        TError,
        AllFactoriesBaselinesControllerPutChildPeriodValueMutationVariables,
        TContext
      > => {
      return useMutation(getAllFactoriesBaselinesControllerPutChildPeriodValueMutationOptions(options), queryClient);
    }
    export type partnerCostCategoriesControllerListResponse200 = {
  data: CostCategoriesResponseDto
  status: 200
}

export type partnerCostCategoriesControllerListResponse403 = {
  data: void
  status: 403
}

export type partnerCostCategoriesControllerListResponse404 = {
  data: void
  status: 404
}

export type partnerCostCategoriesControllerListResponseSuccess = (partnerCostCategoriesControllerListResponse200) & {
  headers: Headers;
};
export type partnerCostCategoriesControllerListResponseError = (partnerCostCategoriesControllerListResponse403 | partnerCostCategoriesControllerListResponse404) & {
  headers: Headers;
};

export type partnerCostCategoriesControllerListResponse = (partnerCostCategoriesControllerListResponseSuccess | partnerCostCategoriesControllerListResponseError)

export const getPartnerCostCategoriesControllerListUrl = (partnerId: string,
    params?: PartnerCostCategoriesControllerListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/partners/${partnerId}/operating-costs/cost-categories?${stringifiedParams}` : `/partners/${partnerId}/operating-costs/cost-categories`
}

/**
 * The three Cost Groups with their predefined Cost Categories (macro to micro) followed by the partner's custom types. Archived custom types are left out unless include_archived is set.
 * @summary The partner's Cost Category lists: predefined, then its own types
 */
export const partnerCostCategoriesControllerList = async (partnerId: string,
    params?: PartnerCostCategoriesControllerListParams, options?: Parameters<typeof customFetch>[1]): Promise<partnerCostCategoriesControllerListResponse> => {

  return customFetch<partnerCostCategoriesControllerListResponse>(getPartnerCostCategoriesControllerListUrl(partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPartnerCostCategoriesControllerListQueryKey = (partnerId: string,
    params?: PartnerCostCategoriesControllerListParams,) => {
    return [
    `/partners/${partnerId}/operating-costs/cost-categories`, ...(params ? [params] : [])
    ] as const;
    }


export const getPartnerCostCategoriesControllerListQueryOptions = <TData = Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError = void>(partnerId: string,
    params?: PartnerCostCategoriesControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPartnerCostCategoriesControllerListQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>> = ({ signal }) => partnerCostCategoriesControllerList(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PartnerCostCategoriesControllerListQueryResult = NonNullable<Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>>
export type PartnerCostCategoriesControllerListQueryError = void


export function usePartnerCostCategoriesControllerList<TData = Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError = void>(
 partnerId: string,
    params: undefined |  PartnerCostCategoriesControllerListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>,
          TError,
          Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePartnerCostCategoriesControllerList<TData = Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError = void>(
 partnerId: string,
    params?: PartnerCostCategoriesControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>,
          TError,
          Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePartnerCostCategoriesControllerList<TData = Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError = void>(
 partnerId: string,
    params?: PartnerCostCategoriesControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The partner's Cost Category lists: predefined, then its own types
 */

export function usePartnerCostCategoriesControllerList<TData = Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError = void>(
 partnerId: string,
    params?: PartnerCostCategoriesControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPartnerCostCategoriesControllerListQueryOptions(partnerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary The partner's Cost Category lists: predefined, then its own types
 */
export const prefetchPartnerCostCategoriesControllerListQuery = async <TData = Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    params?: PartnerCostCategoriesControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getPartnerCostCategoriesControllerListQueryOptions(partnerId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getPartnerCostCategoriesControllerListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError = void>(partnerId: string,
    params?: PartnerCostCategoriesControllerListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPartnerCostCategoriesControllerListQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>> = ({ signal }) => partnerCostCategoriesControllerList(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PartnerCostCategoriesControllerListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>>
export type PartnerCostCategoriesControllerListSuspenseQueryError = void


export function usePartnerCostCategoriesControllerListSuspense<TData = Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError = void>(
 partnerId: string,
    params: undefined |  PartnerCostCategoriesControllerListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePartnerCostCategoriesControllerListSuspense<TData = Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError = void>(
 partnerId: string,
    params?: PartnerCostCategoriesControllerListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePartnerCostCategoriesControllerListSuspense<TData = Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError = void>(
 partnerId: string,
    params?: PartnerCostCategoriesControllerListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The partner's Cost Category lists: predefined, then its own types
 */

export function usePartnerCostCategoriesControllerListSuspense<TData = Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError = void>(
 partnerId: string,
    params?: PartnerCostCategoriesControllerListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPartnerCostCategoriesControllerListSuspenseQueryOptions(partnerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type partnerCostCategoriesControllerCreateResponse201 = {
  data: CostCategoryDto
  status: 201
}

export type partnerCostCategoriesControllerCreateResponse403 = {
  data: void
  status: 403
}

export type partnerCostCategoriesControllerCreateResponse404 = {
  data: void
  status: 404
}

export type partnerCostCategoriesControllerCreateResponse409 = {
  data: void
  status: 409
}

export type partnerCostCategoriesControllerCreateResponse422 = {
  data: void
  status: 422
}

export type partnerCostCategoriesControllerCreateResponseSuccess = (partnerCostCategoriesControllerCreateResponse201) & {
  headers: Headers;
};
export type partnerCostCategoriesControllerCreateResponseError = (partnerCostCategoriesControllerCreateResponse403 | partnerCostCategoriesControllerCreateResponse404 | partnerCostCategoriesControllerCreateResponse409 | partnerCostCategoriesControllerCreateResponse422) & {
  headers: Headers;
};

export type partnerCostCategoriesControllerCreateResponse = (partnerCostCategoriesControllerCreateResponseSuccess | partnerCostCategoriesControllerCreateResponseError)

export const getPartnerCostCategoriesControllerCreateUrl = (partnerId: string,) => {




  return `/partners/${partnerId}/operating-costs/cost-categories`
}

/**
 * A partner's own Cost Line type, offered in every factory's add list beside the predefined categories. The key is the slug of the label ('custom_<slug>'); re-creating an archived type restores it with the new label and code.
 * @summary Add a custom Cost Category
 */
export const partnerCostCategoriesControllerCreate = async (partnerId: string,
    createCustomCostCategoryDto: CreateCustomCostCategoryDto, options?: Parameters<typeof customFetch>[1]): Promise<partnerCostCategoriesControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<partnerCostCategoriesControllerCreateResponse>(getPartnerCostCategoriesControllerCreateUrl(partnerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCustomCostCategoryDto)
  }
);}





export const getPartnerCostCategoriesControllerCreateMutationKey = () => ['partnerCostCategoriesControllerCreate'] as const;

export const getPartnerCostCategoriesControllerCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerCreate>>, TError,PartnerCostCategoriesControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerCreate>>, TError,PartnerCostCategoriesControllerCreateMutationVariables, TContext> => {

const mutationKey = getPartnerCostCategoriesControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof partnerCostCategoriesControllerCreate>>, PartnerCostCategoriesControllerCreateMutationVariables> = (props) => {
          const {partnerId,data} = props ?? {};

          return  partnerCostCategoriesControllerCreate(partnerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PartnerCostCategoriesControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof partnerCostCategoriesControllerCreate>>>
    export type PartnerCostCategoriesControllerCreateMutationBody = CreateCustomCostCategoryDto
    export type PartnerCostCategoriesControllerCreateMutationError = void
    export type PartnerCostCategoriesControllerCreateMutationVariables = {partnerId: string;data: CreateCustomCostCategoryDto}

    /**
 * @summary Add a custom Cost Category
 */
export const usePartnerCostCategoriesControllerCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerCreate>>, TError,PartnerCostCategoriesControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof partnerCostCategoriesControllerCreate>>,
        TError,
        PartnerCostCategoriesControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getPartnerCostCategoriesControllerCreateMutationOptions(options), queryClient);
    }
    export type partnerCostCategoriesControllerArchiveResponse200 = {
  data: CostCategoryDto
  status: 200
}

export type partnerCostCategoriesControllerArchiveResponse400 = {
  data: void
  status: 400
}

export type partnerCostCategoriesControllerArchiveResponse403 = {
  data: void
  status: 403
}

export type partnerCostCategoriesControllerArchiveResponse404 = {
  data: void
  status: 404
}

export type partnerCostCategoriesControllerArchiveResponseSuccess = (partnerCostCategoriesControllerArchiveResponse200) & {
  headers: Headers;
};
export type partnerCostCategoriesControllerArchiveResponseError = (partnerCostCategoriesControllerArchiveResponse400 | partnerCostCategoriesControllerArchiveResponse403 | partnerCostCategoriesControllerArchiveResponse404) & {
  headers: Headers;
};

export type partnerCostCategoriesControllerArchiveResponse = (partnerCostCategoriesControllerArchiveResponseSuccess | partnerCostCategoriesControllerArchiveResponseError)

export const getPartnerCostCategoriesControllerArchiveUrl = (partnerId: string,
    costGroup: string,
    categoryKey: string,) => {




  return `/partners/${partnerId}/operating-costs/cost-categories/${costGroup}/${categoryKey}/archive`
}

/**
 * Hides the type from every add list. Lines already created from it keep their figures and their label. Idempotent.
 * @summary Archive a custom Cost Category
 */
export const partnerCostCategoriesControllerArchive = async (partnerId: string,
    costGroup: string,
    categoryKey: string, options?: Parameters<typeof customFetch>[1]): Promise<partnerCostCategoriesControllerArchiveResponse> => {

  return customFetch<partnerCostCategoriesControllerArchiveResponse>(getPartnerCostCategoriesControllerArchiveUrl(partnerId,costGroup,categoryKey),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPartnerCostCategoriesControllerArchiveMutationKey = () => ['partnerCostCategoriesControllerArchive'] as const;

export const getPartnerCostCategoriesControllerArchiveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerArchive>>, TError,PartnerCostCategoriesControllerArchiveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerArchive>>, TError,PartnerCostCategoriesControllerArchiveMutationVariables, TContext> => {

const mutationKey = getPartnerCostCategoriesControllerArchiveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof partnerCostCategoriesControllerArchive>>, PartnerCostCategoriesControllerArchiveMutationVariables> = (props) => {
          const {partnerId,costGroup,categoryKey} = props ?? {};

          return  partnerCostCategoriesControllerArchive(partnerId,costGroup,categoryKey,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PartnerCostCategoriesControllerArchiveMutationResult = NonNullable<Awaited<ReturnType<typeof partnerCostCategoriesControllerArchive>>>

    export type PartnerCostCategoriesControllerArchiveMutationError = void
    export type PartnerCostCategoriesControllerArchiveMutationVariables = {partnerId: string;costGroup: string;categoryKey: string}

    /**
 * @summary Archive a custom Cost Category
 */
export const usePartnerCostCategoriesControllerArchive = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof partnerCostCategoriesControllerArchive>>, TError,PartnerCostCategoriesControllerArchiveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof partnerCostCategoriesControllerArchive>>,
        TError,
        PartnerCostCategoriesControllerArchiveMutationVariables,
        TContext
      > => {
      return useMutation(getPartnerCostCategoriesControllerArchiveMutationOptions(options), queryClient);
    }
    export type supportLogControllerGetSummaryResponse200 = {
  data: SupportLogSummaryResponseDto
  status: 200
}

export type supportLogControllerGetSummaryResponse400 = {
  data: void
  status: 400
}

export type supportLogControllerGetSummaryResponse404 = {
  data: void
  status: 404
}

export type supportLogControllerGetSummaryResponse422 = {
  data: void
  status: 422
}

export type supportLogControllerGetSummaryResponseSuccess = (supportLogControllerGetSummaryResponse200) & {
  headers: Headers;
};
export type supportLogControllerGetSummaryResponseError = (supportLogControllerGetSummaryResponse400 | supportLogControllerGetSummaryResponse404 | supportLogControllerGetSummaryResponse422) & {
  headers: Headers;
};

export type supportLogControllerGetSummaryResponse = (supportLogControllerGetSummaryResponseSuccess | supportLogControllerGetSummaryResponseError)

export const getSupportLogControllerGetSummaryUrl = (factoryId: string,
    params: SupportLogControllerGetSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/factories/${factoryId}/operating-costs/support-log/summary?${stringifiedParams}` : `/factories/${factoryId}/operating-costs/support-log/summary`
}

/**
 * Read-only aggregate over a day, week or month: Support cost lines as rows, workers with keyed time as columns, plus per-worker over-shift day counts. All duration fields are minutes. A summed cell has no day and no project to write to, so nothing here accepts edits.
 * @summary All Workforce support-hours matrix
 */
export const supportLogControllerGetSummary = async (factoryId: string,
    params: SupportLogControllerGetSummaryParams, options?: Parameters<typeof customFetch>[1]): Promise<supportLogControllerGetSummaryResponse> => {

  return customFetch<supportLogControllerGetSummaryResponse>(getSupportLogControllerGetSummaryUrl(factoryId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSupportLogControllerGetSummaryQueryKey = (factoryId: string,
    params?: SupportLogControllerGetSummaryParams,) => {
    return [
    `/factories/${factoryId}/operating-costs/support-log/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getSupportLogControllerGetSummaryQueryOptions = <TData = Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError = void>(factoryId: string,
    params: SupportLogControllerGetSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportLogControllerGetSummaryQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportLogControllerGetSummary>>> = ({ signal }) => supportLogControllerGetSummary(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportLogControllerGetSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof supportLogControllerGetSummary>>>
export type SupportLogControllerGetSummaryQueryError = void


export function useSupportLogControllerGetSummary<TData = Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError = void>(
 factoryId: string,
    params: SupportLogControllerGetSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportLogControllerGetSummary>>,
          TError,
          Awaited<ReturnType<typeof supportLogControllerGetSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportLogControllerGetSummary<TData = Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError = void>(
 factoryId: string,
    params: SupportLogControllerGetSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportLogControllerGetSummary>>,
          TError,
          Awaited<ReturnType<typeof supportLogControllerGetSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportLogControllerGetSummary<TData = Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError = void>(
 factoryId: string,
    params: SupportLogControllerGetSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary All Workforce support-hours matrix
 */

export function useSupportLogControllerGetSummary<TData = Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError = void>(
 factoryId: string,
    params: SupportLogControllerGetSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportLogControllerGetSummaryQueryOptions(factoryId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary All Workforce support-hours matrix
 */
export const prefetchSupportLogControllerGetSummaryQuery = async <TData = Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError = void>(
 queryClient: QueryClient, factoryId: string,
    params: SupportLogControllerGetSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getSupportLogControllerGetSummaryQueryOptions(factoryId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getSupportLogControllerGetSummarySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError = void>(factoryId: string,
    params: SupportLogControllerGetSummaryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportLogControllerGetSummaryQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportLogControllerGetSummary>>> = ({ signal }) => supportLogControllerGetSummary(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportLogControllerGetSummarySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof supportLogControllerGetSummary>>>
export type SupportLogControllerGetSummarySuspenseQueryError = void


export function useSupportLogControllerGetSummarySuspense<TData = Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError = void>(
 factoryId: string,
    params: SupportLogControllerGetSummaryParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportLogControllerGetSummarySuspense<TData = Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError = void>(
 factoryId: string,
    params: SupportLogControllerGetSummaryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportLogControllerGetSummarySuspense<TData = Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError = void>(
 factoryId: string,
    params: SupportLogControllerGetSummaryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary All Workforce support-hours matrix
 */

export function useSupportLogControllerGetSummarySuspense<TData = Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError = void>(
 factoryId: string,
    params: SupportLogControllerGetSummaryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportLogControllerGetSummarySuspenseQueryOptions(factoryId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type supportLogControllerGetDayResponse200 = {
  data: SupportLogDayResponseDto
  status: 200
}

export type supportLogControllerGetDayResponse400 = {
  data: void
  status: 400
}

export type supportLogControllerGetDayResponse404 = {
  data: void
  status: 404
}

export type supportLogControllerGetDayResponseSuccess = (supportLogControllerGetDayResponse200) & {
  headers: Headers;
};
export type supportLogControllerGetDayResponseError = (supportLogControllerGetDayResponse400 | supportLogControllerGetDayResponse404) & {
  headers: Headers;
};

export type supportLogControllerGetDayResponse = (supportLogControllerGetDayResponseSuccess | supportLogControllerGetDayResponseError)

export const getSupportLogControllerGetDayUrl = (factoryId: string,
    params: SupportLogControllerGetDayParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/factories/${factoryId}/operating-costs/support-log?${stringifiedParams}` : `/factories/${factoryId}/operating-costs/support-log`
}

/**
 * The worker's keyed cells for the day (a blank cell has no row; a keyed 0 is a chosen record of no time) plus the day context: shift minutes, the worker's Value-adding minutes, keyed support minutes and the over-shift flag. The flag never blocks — overtime is real.
 * @summary One worker's Support Log day
 */
export const supportLogControllerGetDay = async (factoryId: string,
    params: SupportLogControllerGetDayParams, options?: Parameters<typeof customFetch>[1]): Promise<supportLogControllerGetDayResponse> => {

  return customFetch<supportLogControllerGetDayResponse>(getSupportLogControllerGetDayUrl(factoryId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSupportLogControllerGetDayQueryKey = (factoryId: string,
    params?: SupportLogControllerGetDayParams,) => {
    return [
    `/factories/${factoryId}/operating-costs/support-log`, ...(params ? [params] : [])
    ] as const;
    }


export const getSupportLogControllerGetDayQueryOptions = <TData = Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError = void>(factoryId: string,
    params: SupportLogControllerGetDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportLogControllerGetDayQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportLogControllerGetDay>>> = ({ signal }) => supportLogControllerGetDay(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportLogControllerGetDayQueryResult = NonNullable<Awaited<ReturnType<typeof supportLogControllerGetDay>>>
export type SupportLogControllerGetDayQueryError = void


export function useSupportLogControllerGetDay<TData = Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError = void>(
 factoryId: string,
    params: SupportLogControllerGetDayParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportLogControllerGetDay>>,
          TError,
          Awaited<ReturnType<typeof supportLogControllerGetDay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportLogControllerGetDay<TData = Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError = void>(
 factoryId: string,
    params: SupportLogControllerGetDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportLogControllerGetDay>>,
          TError,
          Awaited<ReturnType<typeof supportLogControllerGetDay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportLogControllerGetDay<TData = Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError = void>(
 factoryId: string,
    params: SupportLogControllerGetDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One worker's Support Log day
 */

export function useSupportLogControllerGetDay<TData = Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError = void>(
 factoryId: string,
    params: SupportLogControllerGetDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportLogControllerGetDayQueryOptions(factoryId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary One worker's Support Log day
 */
export const prefetchSupportLogControllerGetDayQuery = async <TData = Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError = void>(
 queryClient: QueryClient, factoryId: string,
    params: SupportLogControllerGetDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getSupportLogControllerGetDayQueryOptions(factoryId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getSupportLogControllerGetDaySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError = void>(factoryId: string,
    params: SupportLogControllerGetDayParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportLogControllerGetDayQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportLogControllerGetDay>>> = ({ signal }) => supportLogControllerGetDay(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportLogControllerGetDaySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof supportLogControllerGetDay>>>
export type SupportLogControllerGetDaySuspenseQueryError = void


export function useSupportLogControllerGetDaySuspense<TData = Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError = void>(
 factoryId: string,
    params: SupportLogControllerGetDayParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportLogControllerGetDaySuspense<TData = Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError = void>(
 factoryId: string,
    params: SupportLogControllerGetDayParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportLogControllerGetDaySuspense<TData = Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError = void>(
 factoryId: string,
    params: SupportLogControllerGetDayParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One worker's Support Log day
 */

export function useSupportLogControllerGetDaySuspense<TData = Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError = void>(
 factoryId: string,
    params: SupportLogControllerGetDayParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof supportLogControllerGetDay>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportLogControllerGetDaySuspenseQueryOptions(factoryId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type supportLogControllerPutEntryResponse200 = {
  data: PutSupportLogEntryResponseDto
  status: 200
}

export type supportLogControllerPutEntryResponse400 = {
  data: void
  status: 400
}

export type supportLogControllerPutEntryResponse404 = {
  data: void
  status: 404
}

export type supportLogControllerPutEntryResponse409 = {
  data: void
  status: 409
}

export type supportLogControllerPutEntryResponse422 = {
  data: void
  status: 422
}

export type supportLogControllerPutEntryResponseSuccess = (supportLogControllerPutEntryResponse200) & {
  headers: Headers;
};
export type supportLogControllerPutEntryResponseError = (supportLogControllerPutEntryResponse400 | supportLogControllerPutEntryResponse404 | supportLogControllerPutEntryResponse409 | supportLogControllerPutEntryResponse422) & {
  headers: Headers;
};

export type supportLogControllerPutEntryResponse = (supportLogControllerPutEntryResponseSuccess | supportLogControllerPutEntryResponseError)

export const getSupportLogControllerPutEntryUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/operating-costs/support-log/entries`
}

/**
 * Full-replace of one (cost line, worker, day) cell: minutes and project. Values save as they are keyed — there is no submit — and any past day can be keyed; the audit trail is the control. minutes null clears the cell (deletes the row); a keyed 0 is a real record. Address the line by cost_line_id, or — for a virtual line keyed only at All factories — by line_key: the factory's canonical line is then created, named after the parent, in the same transaction as the entry (or reused when it already exists). Returns the recomputed minute-valued day context so the over-shift flag repaints without a refetch.
 * @summary Key one Support Log cell
 */
export const supportLogControllerPutEntry = async (factoryId: string,
    putSupportLogEntryDto: PutSupportLogEntryDto, options?: Parameters<typeof customFetch>[1]): Promise<supportLogControllerPutEntryResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<supportLogControllerPutEntryResponse>(getSupportLogControllerPutEntryUrl(factoryId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putSupportLogEntryDto)
  }
);}





export const getSupportLogControllerPutEntryMutationKey = () => ['supportLogControllerPutEntry'] as const;

export const getSupportLogControllerPutEntryMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportLogControllerPutEntry>>, TError,SupportLogControllerPutEntryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportLogControllerPutEntry>>, TError,SupportLogControllerPutEntryMutationVariables, TContext> => {

const mutationKey = getSupportLogControllerPutEntryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportLogControllerPutEntry>>, SupportLogControllerPutEntryMutationVariables> = (props) => {
          const {factoryId,data} = props ?? {};

          return  supportLogControllerPutEntry(factoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportLogControllerPutEntryMutationResult = NonNullable<Awaited<ReturnType<typeof supportLogControllerPutEntry>>>
    export type SupportLogControllerPutEntryMutationBody = PutSupportLogEntryDto
    export type SupportLogControllerPutEntryMutationError = void
    export type SupportLogControllerPutEntryMutationVariables = {factoryId: string;data: PutSupportLogEntryDto}

    /**
 * @summary Key one Support Log cell
 */
export const useSupportLogControllerPutEntry = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportLogControllerPutEntry>>, TError,SupportLogControllerPutEntryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportLogControllerPutEntry>>,
        TError,
        SupportLogControllerPutEntryMutationVariables,
        TContext
      > => {
      return useMutation(getSupportLogControllerPutEntryMutationOptions(options), queryClient);
    }
    export type laborControllerEfficiencyResponse200 = {
  data: LaborEfficiencyDto
  status: 200
}

export type laborControllerEfficiencyResponseSuccess = (laborControllerEfficiencyResponse200) & {
  headers: Headers;
};
;

export type laborControllerEfficiencyResponse = (laborControllerEfficiencyResponseSuccess)

export const getLaborControllerEfficiencyUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/operating-costs/labor/efficiency`
}

/**
 * @summary Value-adding and Workforce efficiency over the trailing 8 whole partner weeks, from the materialised dataset
 */
export const laborControllerEfficiency = async (factoryId: string, options?: Parameters<typeof customFetch>[1]): Promise<laborControllerEfficiencyResponse> => {

  return customFetch<laborControllerEfficiencyResponse>(getLaborControllerEfficiencyUrl(factoryId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLaborControllerEfficiencyQueryKey = (factoryId: string,) => {
    return [
    `/factories/${factoryId}/operating-costs/labor/efficiency`
    ] as const;
    }


export const getLaborControllerEfficiencyQueryOptions = <TData = Awaited<ReturnType<typeof laborControllerEfficiency>>, TError = unknown>(factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLaborControllerEfficiencyQueryKey(factoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof laborControllerEfficiency>>> = ({ signal }) => laborControllerEfficiency(factoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof laborControllerEfficiency>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LaborControllerEfficiencyQueryResult = NonNullable<Awaited<ReturnType<typeof laborControllerEfficiency>>>
export type LaborControllerEfficiencyQueryError = unknown


export function useLaborControllerEfficiency<TData = Awaited<ReturnType<typeof laborControllerEfficiency>>, TError = unknown>(
 factoryId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerEfficiency>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof laborControllerEfficiency>>,
          TError,
          Awaited<ReturnType<typeof laborControllerEfficiency>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLaborControllerEfficiency<TData = Awaited<ReturnType<typeof laborControllerEfficiency>>, TError = unknown>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerEfficiency>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof laborControllerEfficiency>>,
          TError,
          Awaited<ReturnType<typeof laborControllerEfficiency>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLaborControllerEfficiency<TData = Awaited<ReturnType<typeof laborControllerEfficiency>>, TError = unknown>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Value-adding and Workforce efficiency over the trailing 8 whole partner weeks, from the materialised dataset
 */

export function useLaborControllerEfficiency<TData = Awaited<ReturnType<typeof laborControllerEfficiency>>, TError = unknown>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLaborControllerEfficiencyQueryOptions(factoryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Value-adding and Workforce efficiency over the trailing 8 whole partner weeks, from the materialised dataset
 */
export const prefetchLaborControllerEfficiencyQuery = async <TData = Awaited<ReturnType<typeof laborControllerEfficiency>>, TError = unknown>(
 queryClient: QueryClient, factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getLaborControllerEfficiencyQueryOptions(factoryId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getLaborControllerEfficiencySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof laborControllerEfficiency>>, TError = unknown>(factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLaborControllerEfficiencyQueryKey(factoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof laborControllerEfficiency>>> = ({ signal }) => laborControllerEfficiency(factoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerEfficiency>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LaborControllerEfficiencySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof laborControllerEfficiency>>>
export type LaborControllerEfficiencySuspenseQueryError = unknown


export function useLaborControllerEfficiencySuspense<TData = Awaited<ReturnType<typeof laborControllerEfficiency>>, TError = unknown>(
 factoryId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLaborControllerEfficiencySuspense<TData = Awaited<ReturnType<typeof laborControllerEfficiency>>, TError = unknown>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLaborControllerEfficiencySuspense<TData = Awaited<ReturnType<typeof laborControllerEfficiency>>, TError = unknown>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Value-adding and Workforce efficiency over the trailing 8 whole partner weeks, from the materialised dataset
 */

export function useLaborControllerEfficiencySuspense<TData = Awaited<ReturnType<typeof laborControllerEfficiency>>, TError = unknown>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLaborControllerEfficiencySuspenseQueryOptions(factoryId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type laborControllerWindowResponse200 = {
  data: LaborWindowDto
  status: 200
}

export type laborControllerWindowResponse400 = {
  data: void
  status: 400
}

export type laborControllerWindowResponseSuccess = (laborControllerWindowResponse200) & {
  headers: Headers;
};
export type laborControllerWindowResponseError = (laborControllerWindowResponse400) & {
  headers: Headers;
};

export type laborControllerWindowResponse = (laborControllerWindowResponseSuccess | laborControllerWindowResponseError)

export const getLaborControllerWindowUrl = (factoryId: string,
    params: LaborControllerWindowParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/factories/${factoryId}/operating-costs/labor?${stringifiedParams}` : `/factories/${factoryId}/operating-costs/labor`
}

/**
 * @summary Labor actuals over a day, week, month or a custom range; all durations are minutes
 */
export const laborControllerWindow = async (factoryId: string,
    params: LaborControllerWindowParams, options?: Parameters<typeof customFetch>[1]): Promise<laborControllerWindowResponse> => {

  return customFetch<laborControllerWindowResponse>(getLaborControllerWindowUrl(factoryId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLaborControllerWindowQueryKey = (factoryId: string,
    params?: LaborControllerWindowParams,) => {
    return [
    `/factories/${factoryId}/operating-costs/labor`, ...(params ? [params] : [])
    ] as const;
    }


export const getLaborControllerWindowQueryOptions = <TData = Awaited<ReturnType<typeof laborControllerWindow>>, TError = void>(factoryId: string,
    params: LaborControllerWindowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLaborControllerWindowQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof laborControllerWindow>>> = ({ signal }) => laborControllerWindow(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof laborControllerWindow>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LaborControllerWindowQueryResult = NonNullable<Awaited<ReturnType<typeof laborControllerWindow>>>
export type LaborControllerWindowQueryError = void


export function useLaborControllerWindow<TData = Awaited<ReturnType<typeof laborControllerWindow>>, TError = void>(
 factoryId: string,
    params: LaborControllerWindowParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerWindow>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof laborControllerWindow>>,
          TError,
          Awaited<ReturnType<typeof laborControllerWindow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLaborControllerWindow<TData = Awaited<ReturnType<typeof laborControllerWindow>>, TError = void>(
 factoryId: string,
    params: LaborControllerWindowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerWindow>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof laborControllerWindow>>,
          TError,
          Awaited<ReturnType<typeof laborControllerWindow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLaborControllerWindow<TData = Awaited<ReturnType<typeof laborControllerWindow>>, TError = void>(
 factoryId: string,
    params: LaborControllerWindowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Labor actuals over a day, week, month or a custom range; all durations are minutes
 */

export function useLaborControllerWindow<TData = Awaited<ReturnType<typeof laborControllerWindow>>, TError = void>(
 factoryId: string,
    params: LaborControllerWindowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLaborControllerWindowQueryOptions(factoryId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Labor actuals over a day, week, month or a custom range; all durations are minutes
 */
export const prefetchLaborControllerWindowQuery = async <TData = Awaited<ReturnType<typeof laborControllerWindow>>, TError = void>(
 queryClient: QueryClient, factoryId: string,
    params: LaborControllerWindowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getLaborControllerWindowQueryOptions(factoryId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getLaborControllerWindowSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof laborControllerWindow>>, TError = void>(factoryId: string,
    params: LaborControllerWindowParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLaborControllerWindowQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof laborControllerWindow>>> = ({ signal }) => laborControllerWindow(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerWindow>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LaborControllerWindowSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof laborControllerWindow>>>
export type LaborControllerWindowSuspenseQueryError = void


export function useLaborControllerWindowSuspense<TData = Awaited<ReturnType<typeof laborControllerWindow>>, TError = void>(
 factoryId: string,
    params: LaborControllerWindowParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLaborControllerWindowSuspense<TData = Awaited<ReturnType<typeof laborControllerWindow>>, TError = void>(
 factoryId: string,
    params: LaborControllerWindowParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLaborControllerWindowSuspense<TData = Awaited<ReturnType<typeof laborControllerWindow>>, TError = void>(
 factoryId: string,
    params: LaborControllerWindowParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Labor actuals over a day, week, month or a custom range; all durations are minutes
 */

export function useLaborControllerWindowSuspense<TData = Awaited<ReturnType<typeof laborControllerWindow>>, TError = void>(
 factoryId: string,
    params: LaborControllerWindowParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLaborControllerWindowSuspenseQueryOptions(factoryId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type laborControllerRecordsResponse200 = {
  data: LaborRecordPageDto
  status: 200
}

export type laborControllerRecordsResponse400 = {
  data: void
  status: 400
}

export type laborControllerRecordsResponseSuccess = (laborControllerRecordsResponse200) & {
  headers: Headers;
};
export type laborControllerRecordsResponseError = (laborControllerRecordsResponse400) & {
  headers: Headers;
};

export type laborControllerRecordsResponse = (laborControllerRecordsResponseSuccess | laborControllerRecordsResponseError)

export const getLaborControllerRecordsUrl = (factoryId: string,
    params: LaborControllerRecordsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/factories/${factoryId}/operating-costs/labor/records?${stringifiedParams}` : `/factories/${factoryId}/operating-costs/labor/records`
}

/**
 * @summary One page of whole logged records for a person or Unallocated fan
 */
export const laborControllerRecords = async (factoryId: string,
    params: LaborControllerRecordsParams, options?: Parameters<typeof customFetch>[1]): Promise<laborControllerRecordsResponse> => {

  return customFetch<laborControllerRecordsResponse>(getLaborControllerRecordsUrl(factoryId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLaborControllerRecordsQueryKey = (factoryId: string,
    params?: LaborControllerRecordsParams,) => {
    return [
    `/factories/${factoryId}/operating-costs/labor/records`, ...(params ? [params] : [])
    ] as const;
    }


export const getLaborControllerRecordsQueryOptions = <TData = Awaited<ReturnType<typeof laborControllerRecords>>, TError = void>(factoryId: string,
    params: LaborControllerRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLaborControllerRecordsQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof laborControllerRecords>>> = ({ signal }) => laborControllerRecords(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof laborControllerRecords>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LaborControllerRecordsQueryResult = NonNullable<Awaited<ReturnType<typeof laborControllerRecords>>>
export type LaborControllerRecordsQueryError = void


export function useLaborControllerRecords<TData = Awaited<ReturnType<typeof laborControllerRecords>>, TError = void>(
 factoryId: string,
    params: LaborControllerRecordsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerRecords>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof laborControllerRecords>>,
          TError,
          Awaited<ReturnType<typeof laborControllerRecords>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLaborControllerRecords<TData = Awaited<ReturnType<typeof laborControllerRecords>>, TError = void>(
 factoryId: string,
    params: LaborControllerRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerRecords>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof laborControllerRecords>>,
          TError,
          Awaited<ReturnType<typeof laborControllerRecords>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLaborControllerRecords<TData = Awaited<ReturnType<typeof laborControllerRecords>>, TError = void>(
 factoryId: string,
    params: LaborControllerRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One page of whole logged records for a person or Unallocated fan
 */

export function useLaborControllerRecords<TData = Awaited<ReturnType<typeof laborControllerRecords>>, TError = void>(
 factoryId: string,
    params: LaborControllerRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLaborControllerRecordsQueryOptions(factoryId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary One page of whole logged records for a person or Unallocated fan
 */
export const prefetchLaborControllerRecordsQuery = async <TData = Awaited<ReturnType<typeof laborControllerRecords>>, TError = void>(
 queryClient: QueryClient, factoryId: string,
    params: LaborControllerRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getLaborControllerRecordsQueryOptions(factoryId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getLaborControllerRecordsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof laborControllerRecords>>, TError = void>(factoryId: string,
    params: LaborControllerRecordsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLaborControllerRecordsQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof laborControllerRecords>>> = ({ signal }) => laborControllerRecords(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerRecords>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LaborControllerRecordsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof laborControllerRecords>>>
export type LaborControllerRecordsSuspenseQueryError = void


export function useLaborControllerRecordsSuspense<TData = Awaited<ReturnType<typeof laborControllerRecords>>, TError = void>(
 factoryId: string,
    params: LaborControllerRecordsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLaborControllerRecordsSuspense<TData = Awaited<ReturnType<typeof laborControllerRecords>>, TError = void>(
 factoryId: string,
    params: LaborControllerRecordsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLaborControllerRecordsSuspense<TData = Awaited<ReturnType<typeof laborControllerRecords>>, TError = void>(
 factoryId: string,
    params: LaborControllerRecordsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One page of whole logged records for a person or Unallocated fan
 */

export function useLaborControllerRecordsSuspense<TData = Awaited<ReturnType<typeof laborControllerRecords>>, TError = void>(
 factoryId: string,
    params: LaborControllerRecordsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLaborControllerRecordsSuspenseQueryOptions(factoryId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type laborControllerHistoryResponse200 = {
  data: LaborHistoryDto[]
  status: 200
}

export type laborControllerHistoryResponseSuccess = (laborControllerHistoryResponse200) & {
  headers: Headers;
};
;

export type laborControllerHistoryResponse = (laborControllerHistoryResponseSuccess)

export const getLaborControllerHistoryUrl = (factoryId: string,
    params?: LaborControllerHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/factories/${factoryId}/operating-costs/labor/history?${stringifiedParams}` : `/factories/${factoryId}/operating-costs/labor/history`
}

/**
 * @summary Audited Labor corrections and their before/after values
 */
export const laborControllerHistory = async (factoryId: string,
    params?: LaborControllerHistoryParams, options?: Parameters<typeof customFetch>[1]): Promise<laborControllerHistoryResponse> => {

  return customFetch<laborControllerHistoryResponse>(getLaborControllerHistoryUrl(factoryId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLaborControllerHistoryQueryKey = (factoryId: string,
    params?: LaborControllerHistoryParams,) => {
    return [
    `/factories/${factoryId}/operating-costs/labor/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getLaborControllerHistoryQueryOptions = <TData = Awaited<ReturnType<typeof laborControllerHistory>>, TError = unknown>(factoryId: string,
    params?: LaborControllerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLaborControllerHistoryQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof laborControllerHistory>>> = ({ signal }) => laborControllerHistory(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof laborControllerHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LaborControllerHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof laborControllerHistory>>>
export type LaborControllerHistoryQueryError = unknown


export function useLaborControllerHistory<TData = Awaited<ReturnType<typeof laborControllerHistory>>, TError = unknown>(
 factoryId: string,
    params: undefined |  LaborControllerHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof laborControllerHistory>>,
          TError,
          Awaited<ReturnType<typeof laborControllerHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLaborControllerHistory<TData = Awaited<ReturnType<typeof laborControllerHistory>>, TError = unknown>(
 factoryId: string,
    params?: LaborControllerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof laborControllerHistory>>,
          TError,
          Awaited<ReturnType<typeof laborControllerHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLaborControllerHistory<TData = Awaited<ReturnType<typeof laborControllerHistory>>, TError = unknown>(
 factoryId: string,
    params?: LaborControllerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Audited Labor corrections and their before/after values
 */

export function useLaborControllerHistory<TData = Awaited<ReturnType<typeof laborControllerHistory>>, TError = unknown>(
 factoryId: string,
    params?: LaborControllerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLaborControllerHistoryQueryOptions(factoryId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Audited Labor corrections and their before/after values
 */
export const prefetchLaborControllerHistoryQuery = async <TData = Awaited<ReturnType<typeof laborControllerHistory>>, TError = unknown>(
 queryClient: QueryClient, factoryId: string,
    params?: LaborControllerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof laborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getLaborControllerHistoryQueryOptions(factoryId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getLaborControllerHistorySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof laborControllerHistory>>, TError = unknown>(factoryId: string,
    params?: LaborControllerHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLaborControllerHistoryQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof laborControllerHistory>>> = ({ signal }) => laborControllerHistory(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LaborControllerHistorySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof laborControllerHistory>>>
export type LaborControllerHistorySuspenseQueryError = unknown


export function useLaborControllerHistorySuspense<TData = Awaited<ReturnType<typeof laborControllerHistory>>, TError = unknown>(
 factoryId: string,
    params: undefined |  LaborControllerHistoryParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLaborControllerHistorySuspense<TData = Awaited<ReturnType<typeof laborControllerHistory>>, TError = unknown>(
 factoryId: string,
    params?: LaborControllerHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLaborControllerHistorySuspense<TData = Awaited<ReturnType<typeof laborControllerHistory>>, TError = unknown>(
 factoryId: string,
    params?: LaborControllerHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Audited Labor corrections and their before/after values
 */

export function useLaborControllerHistorySuspense<TData = Awaited<ReturnType<typeof laborControllerHistory>>, TError = unknown>(
 factoryId: string,
    params?: LaborControllerHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof laborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLaborControllerHistorySuspenseQueryOptions(factoryId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type laborControllerPutDayResponse200 = {
  data: LaborWriteResponseDto
  status: 200
}

export type laborControllerPutDayResponse409 = {
  data: void
  status: 409
}

export type laborControllerPutDayResponse422 = {
  data: void
  status: 422
}

export type laborControllerPutDayResponseSuccess = (laborControllerPutDayResponse200) & {
  headers: Headers;
};
export type laborControllerPutDayResponseError = (laborControllerPutDayResponse409 | laborControllerPutDayResponse422) & {
  headers: Headers;
};

export type laborControllerPutDayResponse = (laborControllerPutDayResponseSuccess | laborControllerPutDayResponseError)

export const getLaborControllerPutDayUrl = (factoryId: string,
    date: string,
    workerId: string,) => {




  return `/factories/${factoryId}/operating-costs/labor/days/${date}/workers/${workerId}`
}

/**
 * @summary Save Absence or shift immediately; return any required unallocation confirmation
 */
export const laborControllerPutDay = async (factoryId: string,
    date: string,
    workerId: string,
    putLaborDayDto: PutLaborDayDto, options?: Parameters<typeof customFetch>[1]): Promise<laborControllerPutDayResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<laborControllerPutDayResponse>(getLaborControllerPutDayUrl(factoryId,date,workerId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putLaborDayDto)
  }
);}





export const getLaborControllerPutDayMutationKey = () => ['laborControllerPutDay'] as const;

export const getLaborControllerPutDayMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof laborControllerPutDay>>, TError,LaborControllerPutDayMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof laborControllerPutDay>>, TError,LaborControllerPutDayMutationVariables, TContext> => {

const mutationKey = getLaborControllerPutDayMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof laborControllerPutDay>>, LaborControllerPutDayMutationVariables> = (props) => {
          const {factoryId,date,workerId,data} = props ?? {};

          return  laborControllerPutDay(factoryId,date,workerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LaborControllerPutDayMutationResult = NonNullable<Awaited<ReturnType<typeof laborControllerPutDay>>>
    export type LaborControllerPutDayMutationBody = PutLaborDayDto
    export type LaborControllerPutDayMutationError = void
    export type LaborControllerPutDayMutationVariables = {factoryId: string;date: string;workerId: string;data: PutLaborDayDto}

    /**
 * @summary Save Absence or shift immediately; return any required unallocation confirmation
 */
export const useLaborControllerPutDay = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof laborControllerPutDay>>, TError,LaborControllerPutDayMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof laborControllerPutDay>>,
        TError,
        LaborControllerPutDayMutationVariables,
        TContext
      > => {
      return useMutation(getLaborControllerPutDayMutationOptions(options), queryClient);
    }
    export type laborControllerReassignResponse201 = {
  data: LaborWindowDto
  status: 201
}

export type laborControllerReassignResponse409 = {
  data: void
  status: 409
}

export type laborControllerReassignResponseSuccess = (laborControllerReassignResponse201) & {
  headers: Headers;
};
export type laborControllerReassignResponseError = (laborControllerReassignResponse409) & {
  headers: Headers;
};

export type laborControllerReassignResponse = (laborControllerReassignResponseSuccess | laborControllerReassignResponseError)

export const getLaborControllerReassignUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/operating-costs/labor/reassign`
}

/**
 * @summary Reassign whole Job Card shift records or Support entries, preserving source quantities
 */
export const laborControllerReassign = async (factoryId: string,
    reassignLaborDto: ReassignLaborDto, options?: Parameters<typeof customFetch>[1]): Promise<laborControllerReassignResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<laborControllerReassignResponse>(getLaborControllerReassignUrl(factoryId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reassignLaborDto)
  }
);}





export const getLaborControllerReassignMutationKey = () => ['laborControllerReassign'] as const;

export const getLaborControllerReassignMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof laborControllerReassign>>, TError,LaborControllerReassignMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof laborControllerReassign>>, TError,LaborControllerReassignMutationVariables, TContext> => {

const mutationKey = getLaborControllerReassignMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof laborControllerReassign>>, LaborControllerReassignMutationVariables> = (props) => {
          const {factoryId,data} = props ?? {};

          return  laborControllerReassign(factoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LaborControllerReassignMutationResult = NonNullable<Awaited<ReturnType<typeof laborControllerReassign>>>
    export type LaborControllerReassignMutationBody = ReassignLaborDto
    export type LaborControllerReassignMutationError = void
    export type LaborControllerReassignMutationVariables = {factoryId: string;data: ReassignLaborDto}

    /**
 * @summary Reassign whole Job Card shift records or Support entries, preserving source quantities
 */
export const useLaborControllerReassign = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof laborControllerReassign>>, TError,LaborControllerReassignMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof laborControllerReassign>>,
        TError,
        LaborControllerReassignMutationVariables,
        TContext
      > => {
      return useMutation(getLaborControllerReassignMutationOptions(options), queryClient);
    }
    export type allFactoriesLaborControllerEfficiencyResponse200 = {
  data: LaborEfficiencyDto
  status: 200
}

export type allFactoriesLaborControllerEfficiencyResponseSuccess = (allFactoriesLaborControllerEfficiencyResponse200) & {
  headers: Headers;
};
;

export type allFactoriesLaborControllerEfficiencyResponse = (allFactoriesLaborControllerEfficiencyResponseSuccess)

export const getAllFactoriesLaborControllerEfficiencyUrl = (partnerId: string,) => {




  return `/partners/${partnerId}/operating-costs/labor/efficiency`
}

/**
 * @summary Value-adding and Workforce efficiency across every factory, over the trailing 8 whole partner weeks
 */
export const allFactoriesLaborControllerEfficiency = async (partnerId: string, options?: Parameters<typeof customFetch>[1]): Promise<allFactoriesLaborControllerEfficiencyResponse> => {

  return customFetch<allFactoriesLaborControllerEfficiencyResponse>(getAllFactoriesLaborControllerEfficiencyUrl(partnerId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAllFactoriesLaborControllerEfficiencyQueryKey = (partnerId: string,) => {
    return [
    `/partners/${partnerId}/operating-costs/labor/efficiency`
    ] as const;
    }


export const getAllFactoriesLaborControllerEfficiencyQueryOptions = <TData = Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError = unknown>(partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllFactoriesLaborControllerEfficiencyQueryKey(partnerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>> = ({ signal }) => allFactoriesLaborControllerEfficiency(partnerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AllFactoriesLaborControllerEfficiencyQueryResult = NonNullable<Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>>
export type AllFactoriesLaborControllerEfficiencyQueryError = unknown


export function useAllFactoriesLaborControllerEfficiency<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError = unknown>(
 partnerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>,
          TError,
          Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesLaborControllerEfficiency<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError = unknown>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>,
          TError,
          Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesLaborControllerEfficiency<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError = unknown>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Value-adding and Workforce efficiency across every factory, over the trailing 8 whole partner weeks
 */

export function useAllFactoriesLaborControllerEfficiency<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError = unknown>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllFactoriesLaborControllerEfficiencyQueryOptions(partnerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Value-adding and Workforce efficiency across every factory, over the trailing 8 whole partner weeks
 */
export const prefetchAllFactoriesLaborControllerEfficiencyQuery = async <TData = Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError = unknown>(
 queryClient: QueryClient, partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getAllFactoriesLaborControllerEfficiencyQueryOptions(partnerId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getAllFactoriesLaborControllerEfficiencySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError = unknown>(partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllFactoriesLaborControllerEfficiencyQueryKey(partnerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>> = ({ signal }) => allFactoriesLaborControllerEfficiency(partnerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AllFactoriesLaborControllerEfficiencySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>>
export type AllFactoriesLaborControllerEfficiencySuspenseQueryError = unknown


export function useAllFactoriesLaborControllerEfficiencySuspense<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError = unknown>(
 partnerId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesLaborControllerEfficiencySuspense<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError = unknown>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesLaborControllerEfficiencySuspense<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError = unknown>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Value-adding and Workforce efficiency across every factory, over the trailing 8 whole partner weeks
 */

export function useAllFactoriesLaborControllerEfficiencySuspense<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError = unknown>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerEfficiency>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllFactoriesLaborControllerEfficiencySuspenseQueryOptions(partnerId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type allFactoriesLaborControllerWindowResponse200 = {
  data: PartnerLaborWindowDto
  status: 200
}

export type allFactoriesLaborControllerWindowResponse400 = {
  data: void
  status: 400
}

export type allFactoriesLaborControllerWindowResponseSuccess = (allFactoriesLaborControllerWindowResponse200) & {
  headers: Headers;
};
export type allFactoriesLaborControllerWindowResponseError = (allFactoriesLaborControllerWindowResponse400) & {
  headers: Headers;
};

export type allFactoriesLaborControllerWindowResponse = (allFactoriesLaborControllerWindowResponseSuccess | allFactoriesLaborControllerWindowResponseError)

export const getAllFactoriesLaborControllerWindowUrl = (partnerId: string,
    params: AllFactoriesLaborControllerWindowParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/partners/${partnerId}/operating-costs/labor?${stringifiedParams}` : `/partners/${partnerId}/operating-costs/labor`
}

/**
 * @summary Labor actuals across every factory over a day, week, month or a custom range; durations are minutes
 */
export const allFactoriesLaborControllerWindow = async (partnerId: string,
    params: AllFactoriesLaborControllerWindowParams, options?: Parameters<typeof customFetch>[1]): Promise<allFactoriesLaborControllerWindowResponse> => {

  return customFetch<allFactoriesLaborControllerWindowResponse>(getAllFactoriesLaborControllerWindowUrl(partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAllFactoriesLaborControllerWindowQueryKey = (partnerId: string,
    params?: AllFactoriesLaborControllerWindowParams,) => {
    return [
    `/partners/${partnerId}/operating-costs/labor`, ...(params ? [params] : [])
    ] as const;
    }


export const getAllFactoriesLaborControllerWindowQueryOptions = <TData = Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError = void>(partnerId: string,
    params: AllFactoriesLaborControllerWindowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllFactoriesLaborControllerWindowQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>> = ({ signal }) => allFactoriesLaborControllerWindow(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AllFactoriesLaborControllerWindowQueryResult = NonNullable<Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>>
export type AllFactoriesLaborControllerWindowQueryError = void


export function useAllFactoriesLaborControllerWindow<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError = void>(
 partnerId: string,
    params: AllFactoriesLaborControllerWindowParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>,
          TError,
          Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesLaborControllerWindow<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError = void>(
 partnerId: string,
    params: AllFactoriesLaborControllerWindowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>,
          TError,
          Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesLaborControllerWindow<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError = void>(
 partnerId: string,
    params: AllFactoriesLaborControllerWindowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Labor actuals across every factory over a day, week, month or a custom range; durations are minutes
 */

export function useAllFactoriesLaborControllerWindow<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError = void>(
 partnerId: string,
    params: AllFactoriesLaborControllerWindowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllFactoriesLaborControllerWindowQueryOptions(partnerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Labor actuals across every factory over a day, week, month or a custom range; durations are minutes
 */
export const prefetchAllFactoriesLaborControllerWindowQuery = async <TData = Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    params: AllFactoriesLaborControllerWindowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getAllFactoriesLaborControllerWindowQueryOptions(partnerId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getAllFactoriesLaborControllerWindowSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError = void>(partnerId: string,
    params: AllFactoriesLaborControllerWindowParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllFactoriesLaborControllerWindowQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>> = ({ signal }) => allFactoriesLaborControllerWindow(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AllFactoriesLaborControllerWindowSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>>
export type AllFactoriesLaborControllerWindowSuspenseQueryError = void


export function useAllFactoriesLaborControllerWindowSuspense<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError = void>(
 partnerId: string,
    params: AllFactoriesLaborControllerWindowParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesLaborControllerWindowSuspense<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError = void>(
 partnerId: string,
    params: AllFactoriesLaborControllerWindowParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesLaborControllerWindowSuspense<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError = void>(
 partnerId: string,
    params: AllFactoriesLaborControllerWindowParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Labor actuals across every factory over a day, week, month or a custom range; durations are minutes
 */

export function useAllFactoriesLaborControllerWindowSuspense<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError = void>(
 partnerId: string,
    params: AllFactoriesLaborControllerWindowParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerWindow>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllFactoriesLaborControllerWindowSuspenseQueryOptions(partnerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type allFactoriesLaborControllerRecordsResponse200 = {
  data: LaborRecordPageDto
  status: 200
}

export type allFactoriesLaborControllerRecordsResponse400 = {
  data: void
  status: 400
}

export type allFactoriesLaborControllerRecordsResponseSuccess = (allFactoriesLaborControllerRecordsResponse200) & {
  headers: Headers;
};
export type allFactoriesLaborControllerRecordsResponseError = (allFactoriesLaborControllerRecordsResponse400) & {
  headers: Headers;
};

export type allFactoriesLaborControllerRecordsResponse = (allFactoriesLaborControllerRecordsResponseSuccess | allFactoriesLaborControllerRecordsResponseError)

export const getAllFactoriesLaborControllerRecordsUrl = (partnerId: string,
    params: AllFactoriesLaborControllerRecordsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/partners/${partnerId}/operating-costs/labor/records?${stringifiedParams}` : `/partners/${partnerId}/operating-costs/labor/records`
}

/**
 * @summary One page of whole logged records for a person or Unallocated fan, across factories
 */
export const allFactoriesLaborControllerRecords = async (partnerId: string,
    params: AllFactoriesLaborControllerRecordsParams, options?: Parameters<typeof customFetch>[1]): Promise<allFactoriesLaborControllerRecordsResponse> => {

  return customFetch<allFactoriesLaborControllerRecordsResponse>(getAllFactoriesLaborControllerRecordsUrl(partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAllFactoriesLaborControllerRecordsQueryKey = (partnerId: string,
    params?: AllFactoriesLaborControllerRecordsParams,) => {
    return [
    `/partners/${partnerId}/operating-costs/labor/records`, ...(params ? [params] : [])
    ] as const;
    }


export const getAllFactoriesLaborControllerRecordsQueryOptions = <TData = Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError = void>(partnerId: string,
    params: AllFactoriesLaborControllerRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllFactoriesLaborControllerRecordsQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>> = ({ signal }) => allFactoriesLaborControllerRecords(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AllFactoriesLaborControllerRecordsQueryResult = NonNullable<Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>>
export type AllFactoriesLaborControllerRecordsQueryError = void


export function useAllFactoriesLaborControllerRecords<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError = void>(
 partnerId: string,
    params: AllFactoriesLaborControllerRecordsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>,
          TError,
          Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesLaborControllerRecords<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError = void>(
 partnerId: string,
    params: AllFactoriesLaborControllerRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>,
          TError,
          Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesLaborControllerRecords<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError = void>(
 partnerId: string,
    params: AllFactoriesLaborControllerRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One page of whole logged records for a person or Unallocated fan, across factories
 */

export function useAllFactoriesLaborControllerRecords<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError = void>(
 partnerId: string,
    params: AllFactoriesLaborControllerRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllFactoriesLaborControllerRecordsQueryOptions(partnerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary One page of whole logged records for a person or Unallocated fan, across factories
 */
export const prefetchAllFactoriesLaborControllerRecordsQuery = async <TData = Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    params: AllFactoriesLaborControllerRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getAllFactoriesLaborControllerRecordsQueryOptions(partnerId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getAllFactoriesLaborControllerRecordsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError = void>(partnerId: string,
    params: AllFactoriesLaborControllerRecordsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllFactoriesLaborControllerRecordsQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>> = ({ signal }) => allFactoriesLaborControllerRecords(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AllFactoriesLaborControllerRecordsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>>
export type AllFactoriesLaborControllerRecordsSuspenseQueryError = void


export function useAllFactoriesLaborControllerRecordsSuspense<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError = void>(
 partnerId: string,
    params: AllFactoriesLaborControllerRecordsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesLaborControllerRecordsSuspense<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError = void>(
 partnerId: string,
    params: AllFactoriesLaborControllerRecordsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesLaborControllerRecordsSuspense<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError = void>(
 partnerId: string,
    params: AllFactoriesLaborControllerRecordsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One page of whole logged records for a person or Unallocated fan, across factories
 */

export function useAllFactoriesLaborControllerRecordsSuspense<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError = void>(
 partnerId: string,
    params: AllFactoriesLaborControllerRecordsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllFactoriesLaborControllerRecordsSuspenseQueryOptions(partnerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type allFactoriesLaborControllerHistoryResponse200 = {
  data: LaborHistoryDto[]
  status: 200
}

export type allFactoriesLaborControllerHistoryResponseSuccess = (allFactoriesLaborControllerHistoryResponse200) & {
  headers: Headers;
};
;

export type allFactoriesLaborControllerHistoryResponse = (allFactoriesLaborControllerHistoryResponseSuccess)

export const getAllFactoriesLaborControllerHistoryUrl = (partnerId: string,
    params?: AllFactoriesLaborControllerHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/partners/${partnerId}/operating-costs/labor/history?${stringifiedParams}` : `/partners/${partnerId}/operating-costs/labor/history`
}

/**
 * @summary Audited Labor corrections for the partner
 */
export const allFactoriesLaborControllerHistory = async (partnerId: string,
    params?: AllFactoriesLaborControllerHistoryParams, options?: Parameters<typeof customFetch>[1]): Promise<allFactoriesLaborControllerHistoryResponse> => {

  return customFetch<allFactoriesLaborControllerHistoryResponse>(getAllFactoriesLaborControllerHistoryUrl(partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAllFactoriesLaborControllerHistoryQueryKey = (partnerId: string,
    params?: AllFactoriesLaborControllerHistoryParams,) => {
    return [
    `/partners/${partnerId}/operating-costs/labor/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getAllFactoriesLaborControllerHistoryQueryOptions = <TData = Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError = unknown>(partnerId: string,
    params?: AllFactoriesLaborControllerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllFactoriesLaborControllerHistoryQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>> = ({ signal }) => allFactoriesLaborControllerHistory(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AllFactoriesLaborControllerHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>>
export type AllFactoriesLaborControllerHistoryQueryError = unknown


export function useAllFactoriesLaborControllerHistory<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError = unknown>(
 partnerId: string,
    params: undefined |  AllFactoriesLaborControllerHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>,
          TError,
          Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesLaborControllerHistory<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError = unknown>(
 partnerId: string,
    params?: AllFactoriesLaborControllerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>,
          TError,
          Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesLaborControllerHistory<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError = unknown>(
 partnerId: string,
    params?: AllFactoriesLaborControllerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Audited Labor corrections for the partner
 */

export function useAllFactoriesLaborControllerHistory<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError = unknown>(
 partnerId: string,
    params?: AllFactoriesLaborControllerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllFactoriesLaborControllerHistoryQueryOptions(partnerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Audited Labor corrections for the partner
 */
export const prefetchAllFactoriesLaborControllerHistoryQuery = async <TData = Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError = unknown>(
 queryClient: QueryClient, partnerId: string,
    params?: AllFactoriesLaborControllerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getAllFactoriesLaborControllerHistoryQueryOptions(partnerId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getAllFactoriesLaborControllerHistorySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError = unknown>(partnerId: string,
    params?: AllFactoriesLaborControllerHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllFactoriesLaborControllerHistoryQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>> = ({ signal }) => allFactoriesLaborControllerHistory(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AllFactoriesLaborControllerHistorySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>>
export type AllFactoriesLaborControllerHistorySuspenseQueryError = unknown


export function useAllFactoriesLaborControllerHistorySuspense<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError = unknown>(
 partnerId: string,
    params: undefined |  AllFactoriesLaborControllerHistoryParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesLaborControllerHistorySuspense<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError = unknown>(
 partnerId: string,
    params?: AllFactoriesLaborControllerHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllFactoriesLaborControllerHistorySuspense<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError = unknown>(
 partnerId: string,
    params?: AllFactoriesLaborControllerHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Audited Labor corrections for the partner
 */

export function useAllFactoriesLaborControllerHistorySuspense<TData = Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError = unknown>(
 partnerId: string,
    params?: AllFactoriesLaborControllerHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allFactoriesLaborControllerHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllFactoriesLaborControllerHistorySuspenseQueryOptions(partnerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type budgetsControllerGetResponse200 = {
  data: BudgetsResponseDto
  status: 200
}

export type budgetsControllerGetResponse403 = {
  data: void
  status: 403
}

export type budgetsControllerGetResponseSuccess = (budgetsControllerGetResponse200) & {
  headers: Headers;
};
export type budgetsControllerGetResponseError = (budgetsControllerGetResponse403) & {
  headers: Headers;
};

export type budgetsControllerGetResponse = (budgetsControllerGetResponseSuccess | budgetsControllerGetResponseError)

export const getBudgetsControllerGetUrl = (partnerId: string,) => {




  return `/partners/${partnerId}/operating-costs/budgets`
}

/**
 * @summary Budget lines for every project with live work orders, with what each is keyed at per day, week and month
 */
export const budgetsControllerGet = async (partnerId: string, options?: Parameters<typeof customFetch>[1]): Promise<budgetsControllerGetResponse> => {

  return customFetch<budgetsControllerGetResponse>(getBudgetsControllerGetUrl(partnerId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBudgetsControllerGetQueryKey = (partnerId: string,) => {
    return [
    `/partners/${partnerId}/operating-costs/budgets`
    ] as const;
    }


export const getBudgetsControllerGetQueryOptions = <TData = Awaited<ReturnType<typeof budgetsControllerGet>>, TError = void>(partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof budgetsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBudgetsControllerGetQueryKey(partnerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof budgetsControllerGet>>> = ({ signal }) => budgetsControllerGet(partnerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof budgetsControllerGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BudgetsControllerGetQueryResult = NonNullable<Awaited<ReturnType<typeof budgetsControllerGet>>>
export type BudgetsControllerGetQueryError = void


export function useBudgetsControllerGet<TData = Awaited<ReturnType<typeof budgetsControllerGet>>, TError = void>(
 partnerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof budgetsControllerGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof budgetsControllerGet>>,
          TError,
          Awaited<ReturnType<typeof budgetsControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBudgetsControllerGet<TData = Awaited<ReturnType<typeof budgetsControllerGet>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof budgetsControllerGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof budgetsControllerGet>>,
          TError,
          Awaited<ReturnType<typeof budgetsControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBudgetsControllerGet<TData = Awaited<ReturnType<typeof budgetsControllerGet>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof budgetsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Budget lines for every project with live work orders, with what each is keyed at per day, week and month
 */

export function useBudgetsControllerGet<TData = Awaited<ReturnType<typeof budgetsControllerGet>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof budgetsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBudgetsControllerGetQueryOptions(partnerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Budget lines for every project with live work orders, with what each is keyed at per day, week and month
 */
export const prefetchBudgetsControllerGetQuery = async <TData = Awaited<ReturnType<typeof budgetsControllerGet>>, TError = void>(
 queryClient: QueryClient, partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof budgetsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getBudgetsControllerGetQueryOptions(partnerId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getBudgetsControllerGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof budgetsControllerGet>>, TError = void>(partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof budgetsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBudgetsControllerGetQueryKey(partnerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof budgetsControllerGet>>> = ({ signal }) => budgetsControllerGet(partnerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof budgetsControllerGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BudgetsControllerGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof budgetsControllerGet>>>
export type BudgetsControllerGetSuspenseQueryError = void


export function useBudgetsControllerGetSuspense<TData = Awaited<ReturnType<typeof budgetsControllerGet>>, TError = void>(
 partnerId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof budgetsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBudgetsControllerGetSuspense<TData = Awaited<ReturnType<typeof budgetsControllerGet>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof budgetsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBudgetsControllerGetSuspense<TData = Awaited<ReturnType<typeof budgetsControllerGet>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof budgetsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Budget lines for every project with live work orders, with what each is keyed at per day, week and month
 */

export function useBudgetsControllerGetSuspense<TData = Awaited<ReturnType<typeof budgetsControllerGet>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof budgetsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBudgetsControllerGetSuspenseQueryOptions(partnerId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type budgetsControllerPutResponse200 = {
  data: PutBudgetLineResponseDto
  status: 200
}

export type budgetsControllerPutResponse400 = {
  data: void
  status: 400
}

export type budgetsControllerPutResponse403 = {
  data: void
  status: 403
}

export type budgetsControllerPutResponse404 = {
  data: void
  status: 404
}

export type budgetsControllerPutResponse422 = {
  data: void
  status: 422
}

export type budgetsControllerPutResponseSuccess = (budgetsControllerPutResponse200) & {
  headers: Headers;
};
export type budgetsControllerPutResponseError = (budgetsControllerPutResponse400 | budgetsControllerPutResponse403 | budgetsControllerPutResponse404 | budgetsControllerPutResponse422) & {
  headers: Headers;
};

export type budgetsControllerPutResponse = (budgetsControllerPutResponseSuccess | budgetsControllerPutResponseError)

export const getBudgetsControllerPutUrl = (partnerId: string,
    projectId: string,
    lineKey: string,) => {




  return `/partners/${partnerId}/operating-costs/budgets/${projectId}/lines/${lineKey}`
}

/**
 * @summary Key one budget line; absent fields are unchanged, null clears, all null deletes
 */
export const budgetsControllerPut = async (partnerId: string,
    projectId: string,
    lineKey: string,
    putBudgetLineDto: PutBudgetLineDto, options?: Parameters<typeof customFetch>[1]): Promise<budgetsControllerPutResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<budgetsControllerPutResponse>(getBudgetsControllerPutUrl(partnerId,projectId,lineKey),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putBudgetLineDto)
  }
);}





export const getBudgetsControllerPutMutationKey = () => ['budgetsControllerPut'] as const;

export const getBudgetsControllerPutMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof budgetsControllerPut>>, TError,BudgetsControllerPutMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof budgetsControllerPut>>, TError,BudgetsControllerPutMutationVariables, TContext> => {

const mutationKey = getBudgetsControllerPutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof budgetsControllerPut>>, BudgetsControllerPutMutationVariables> = (props) => {
          const {partnerId,projectId,lineKey,data} = props ?? {};

          return  budgetsControllerPut(partnerId,projectId,lineKey,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BudgetsControllerPutMutationResult = NonNullable<Awaited<ReturnType<typeof budgetsControllerPut>>>
    export type BudgetsControllerPutMutationBody = PutBudgetLineDto
    export type BudgetsControllerPutMutationError = void
    export type BudgetsControllerPutMutationVariables = {partnerId: string;projectId: string;lineKey: string;data: PutBudgetLineDto}

    /**
 * @summary Key one budget line; absent fields are unchanged, null clears, all null deletes
 */
export const useBudgetsControllerPut = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof budgetsControllerPut>>, TError,BudgetsControllerPutMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof budgetsControllerPut>>,
        TError,
        BudgetsControllerPutMutationVariables,
        TContext
      > => {
      return useMutation(getBudgetsControllerPutMutationOptions(options), queryClient);
    }
    export type costToProduceControllerProjectsResponse200 = {
  data: CostToProduceProjectsDto
  status: 200
}

export type costToProduceControllerProjectsResponse403 = {
  data: void
  status: 403
}

export type costToProduceControllerProjectsResponseSuccess = (costToProduceControllerProjectsResponse200) & {
  headers: Headers;
};
export type costToProduceControllerProjectsResponseError = (costToProduceControllerProjectsResponse403) & {
  headers: Headers;
};

export type costToProduceControllerProjectsResponse = (costToProduceControllerProjectsResponseSuccess | costToProduceControllerProjectsResponseError)

export const getCostToProduceControllerProjectsUrl = (partnerId: string,
    params?: CostToProduceControllerProjectsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/partners/${partnerId}/operating-costs/cost-to-produce/projects?${stringifiedParams}` : `/partners/${partnerId}/operating-costs/cost-to-produce/projects`
}

/**
 * @summary Cost to Produce per released project: planned, actual, budget, forecast and delivery, in shift minutes
 */
export const costToProduceControllerProjects = async (partnerId: string,
    params?: CostToProduceControllerProjectsParams, options?: Parameters<typeof customFetch>[1]): Promise<costToProduceControllerProjectsResponse> => {

  return customFetch<costToProduceControllerProjectsResponse>(getCostToProduceControllerProjectsUrl(partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCostToProduceControllerProjectsQueryKey = (partnerId: string,
    params?: CostToProduceControllerProjectsParams,) => {
    return [
    `/partners/${partnerId}/operating-costs/cost-to-produce/projects`, ...(params ? [params] : [])
    ] as const;
    }


export const getCostToProduceControllerProjectsQueryOptions = <TData = Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError = void>(partnerId: string,
    params?: CostToProduceControllerProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCostToProduceControllerProjectsQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof costToProduceControllerProjects>>> = ({ signal }) => costToProduceControllerProjects(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CostToProduceControllerProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof costToProduceControllerProjects>>>
export type CostToProduceControllerProjectsQueryError = void


export function useCostToProduceControllerProjects<TData = Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError = void>(
 partnerId: string,
    params: undefined |  CostToProduceControllerProjectsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof costToProduceControllerProjects>>,
          TError,
          Awaited<ReturnType<typeof costToProduceControllerProjects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCostToProduceControllerProjects<TData = Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError = void>(
 partnerId: string,
    params?: CostToProduceControllerProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof costToProduceControllerProjects>>,
          TError,
          Awaited<ReturnType<typeof costToProduceControllerProjects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCostToProduceControllerProjects<TData = Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError = void>(
 partnerId: string,
    params?: CostToProduceControllerProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Cost to Produce per released project: planned, actual, budget, forecast and delivery, in shift minutes
 */

export function useCostToProduceControllerProjects<TData = Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError = void>(
 partnerId: string,
    params?: CostToProduceControllerProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCostToProduceControllerProjectsQueryOptions(partnerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Cost to Produce per released project: planned, actual, budget, forecast and delivery, in shift minutes
 */
export const prefetchCostToProduceControllerProjectsQuery = async <TData = Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    params?: CostToProduceControllerProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getCostToProduceControllerProjectsQueryOptions(partnerId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getCostToProduceControllerProjectsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError = void>(partnerId: string,
    params?: CostToProduceControllerProjectsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCostToProduceControllerProjectsQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof costToProduceControllerProjects>>> = ({ signal }) => costToProduceControllerProjects(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CostToProduceControllerProjectsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof costToProduceControllerProjects>>>
export type CostToProduceControllerProjectsSuspenseQueryError = void


export function useCostToProduceControllerProjectsSuspense<TData = Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError = void>(
 partnerId: string,
    params: undefined |  CostToProduceControllerProjectsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCostToProduceControllerProjectsSuspense<TData = Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError = void>(
 partnerId: string,
    params?: CostToProduceControllerProjectsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCostToProduceControllerProjectsSuspense<TData = Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError = void>(
 partnerId: string,
    params?: CostToProduceControllerProjectsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Cost to Produce per released project: planned, actual, budget, forecast and delivery, in shift minutes
 */

export function useCostToProduceControllerProjectsSuspense<TData = Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError = void>(
 partnerId: string,
    params?: CostToProduceControllerProjectsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCostToProduceControllerProjectsSuspenseQueryOptions(partnerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type costToProduceControllerWorkOrdersResponse200 = {
  data: CostToProduceWorkOrdersDto
  status: 200
}

export type costToProduceControllerWorkOrdersResponse403 = {
  data: void
  status: 403
}

export type costToProduceControllerWorkOrdersResponse404 = {
  data: void
  status: 404
}

export type costToProduceControllerWorkOrdersResponseSuccess = (costToProduceControllerWorkOrdersResponse200) & {
  headers: Headers;
};
export type costToProduceControllerWorkOrdersResponseError = (costToProduceControllerWorkOrdersResponse403 | costToProduceControllerWorkOrdersResponse404) & {
  headers: Headers;
};

export type costToProduceControllerWorkOrdersResponse = (costToProduceControllerWorkOrdersResponseSuccess | costToProduceControllerWorkOrdersResponseError)

export const getCostToProduceControllerWorkOrdersUrl = (partnerId: string,
    params?: CostToProduceControllerWorkOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/partners/${partnerId}/operating-costs/cost-to-produce/work-orders?${stringifiedParams}` : `/partners/${partnerId}/operating-costs/cost-to-produce/work-orders`
}

/**
 * @summary Cost to Produce per work order of one project; without project_id, just the project summaries
 */
export const costToProduceControllerWorkOrders = async (partnerId: string,
    params?: CostToProduceControllerWorkOrdersParams, options?: Parameters<typeof customFetch>[1]): Promise<costToProduceControllerWorkOrdersResponse> => {

  return customFetch<costToProduceControllerWorkOrdersResponse>(getCostToProduceControllerWorkOrdersUrl(partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCostToProduceControllerWorkOrdersQueryKey = (partnerId: string,
    params?: CostToProduceControllerWorkOrdersParams,) => {
    return [
    `/partners/${partnerId}/operating-costs/cost-to-produce/work-orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getCostToProduceControllerWorkOrdersQueryOptions = <TData = Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError = void>(partnerId: string,
    params?: CostToProduceControllerWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCostToProduceControllerWorkOrdersQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>> = ({ signal }) => costToProduceControllerWorkOrders(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CostToProduceControllerWorkOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>>
export type CostToProduceControllerWorkOrdersQueryError = void


export function useCostToProduceControllerWorkOrders<TData = Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError = void>(
 partnerId: string,
    params: undefined |  CostToProduceControllerWorkOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCostToProduceControllerWorkOrders<TData = Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError = void>(
 partnerId: string,
    params?: CostToProduceControllerWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCostToProduceControllerWorkOrders<TData = Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError = void>(
 partnerId: string,
    params?: CostToProduceControllerWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Cost to Produce per work order of one project; without project_id, just the project summaries
 */

export function useCostToProduceControllerWorkOrders<TData = Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError = void>(
 partnerId: string,
    params?: CostToProduceControllerWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCostToProduceControllerWorkOrdersQueryOptions(partnerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Cost to Produce per work order of one project; without project_id, just the project summaries
 */
export const prefetchCostToProduceControllerWorkOrdersQuery = async <TData = Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    params?: CostToProduceControllerWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getCostToProduceControllerWorkOrdersQueryOptions(partnerId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getCostToProduceControllerWorkOrdersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError = void>(partnerId: string,
    params?: CostToProduceControllerWorkOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCostToProduceControllerWorkOrdersQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>> = ({ signal }) => costToProduceControllerWorkOrders(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CostToProduceControllerWorkOrdersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>>
export type CostToProduceControllerWorkOrdersSuspenseQueryError = void


export function useCostToProduceControllerWorkOrdersSuspense<TData = Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError = void>(
 partnerId: string,
    params: undefined |  CostToProduceControllerWorkOrdersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCostToProduceControllerWorkOrdersSuspense<TData = Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError = void>(
 partnerId: string,
    params?: CostToProduceControllerWorkOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCostToProduceControllerWorkOrdersSuspense<TData = Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError = void>(
 partnerId: string,
    params?: CostToProduceControllerWorkOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Cost to Produce per work order of one project; without project_id, just the project summaries
 */

export function useCostToProduceControllerWorkOrdersSuspense<TData = Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError = void>(
 partnerId: string,
    params?: CostToProduceControllerWorkOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof costToProduceControllerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCostToProduceControllerWorkOrdersSuspenseQueryOptions(partnerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






